import { ResponsiveBootstrapToolkit, Mousetrap, moment, Bugsnag, CountUp } from './third-party'

import { isProduction, getSubdomain, p, createAlert, createModal, isDVTeam, analyticsEvent } from './utils'
import Snowflakes from 'magic-snowflakes'
import { PostcodeLookup } from './classes/postcodeLookup.js'

if (isProduction()) {
  Bugsnag.start({
    apiKey: '5c65c5b7e69a35d8b8f1a51d55ddbcee',
    releaseStage: getSubdomain() === 'staging-www' ? 'staging' : 'production'
  })
}

/**
Taken from https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-dollars-currency-string-in-javascript
* Number.prototype.format(n, x)
*
* @param integer n: length of decimal
* @param integer x: length of sections
*/
Number.prototype.numberFormat = function (n, x) {
  const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')'
  return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,')
}

/* Fixes below for bootstrap 3 modals when stacking multiple bootstrap modals - the modals need to increase the z-index of the previous on to cover the previous modal
https://stackoverflow.com/questions/19305821/multiple-modals-overlay
*/
$(document).on('show.bs.modal', '.modal', function () {
  const zIndex = 1040 + (10 * $('.modal:visible').length)
  $(this).css('z-index', zIndex)
  setTimeout(function () {
    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack')
  }, 0)
})
$(document).on('hidden.bs.modal', '.modal', function () {
  $('.modal:visible').length && $(document.body).addClass('modal-open')
})
/* end bootstrap 3 modal fixes when stacking */

/**
* Debounce function - for limiting function calls. Useful when running functions on scroll, window-resize .etc
*
* Returns a function, that, as long as it continues to be invoked, will not
* be triggered. The function will be called after it stops being called for N milliseconds.
* If 'immediate' is passed, trigger the function on the leading edge, instead of the trailing.
*
* Originally borrowed from Underscore.js - via https://davidwalsh.name/javascript-debounce-function
*
* @param func
* @param wait
* @param immediate
* @return {Function}
*/
function debounce(func, wait, immediate) {
  let timeout
  return function () {
    const context = this; const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

let resetAutoCompleteForm // need this defined in outer scope as some of the inner functions clal it from different areas
let displayNoFlightResultsWarning // need this defined in outer scope so the inner functions can use it in multiple places.
function setupSearchResultsCarousel() {
  $('.villa-image').not('.slick-initialized').slick({
    arrows: true,
    dots: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    lazyLoad: 'anticipated',
    rows: 0, // we set this as 0 else a row of 1 (the default) ads a weird line height which makes the items larger in height and the overlays extend below the bottom of the image.
    responsive: [
      {
        // xs
        breakpoint: 767,
        settings: {
          // slidesToShow: 1,
          // slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px'
          // adaptiveHeight: true,
        }
      }
    ]
  })
  $('.villa-image').on('afterChange', function (event, slick, currentSlide) {
    const slide = $(this)
    const currentSlideEl = slick.$slides[currentSlide]
    const $currentSlide = $(currentSlideEl)
    $currentSlide.closest('.villa-image-and-highlight-container').find('.carousel-image-number').find('.carousel-image-number-current').html((currentSlide + 1))
  })
}
function checkCarHireDriverAgeSetCorrectly(driverAgeValue) {
  let driverAgeErrorTooltip = ''
  if (driverAgeValue) {
    if (isNaN(driverAgeValue)) {
      driverAgeErrorTooltip = 'Driver age must be a number'
    }
    if (driverAgeValue < 21) {
      driverAgeErrorTooltip = 'Driver age minimum is 21'
    }
    if (driverAgeValue > 99) {
      driverAgeErrorTooltip = 'Driver age maximum is 99'
    }
  } else {
    driverAgeErrorTooltip = 'Please enter a driver age'
  }
  return driverAgeErrorTooltip
}
/**
*  ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ========================================================================
* */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  const Debbies = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        /**
        * --------------------------
        * Functions we will be using
        * --------------------------
        */

        /**
        * Set the responsive hero image
        * @param viewport
        */
        function responsiveHeroImage(viewport) {
          let bgSelector
          let bgImage

          if (!$('#masthead').length) {
            return false
          }

          if (viewport.is('xs')) {
            if ($('#masthead').children('.inner').attr('data-xs-bg')) {
              if ($('#masthead').children('.inner').attr('data-xs-bg') !== '') {
                bgSelector = 'data-xs-bg'
              }
            }
          }

          if (viewport.is('sm')) {
            if ($('#masthead').children('.inner').attr('data-sm-bg')) {
              if ($('#masthead').children('.inner').attr('data-sm-bg') !== '') {
                bgSelector = 'data-sm-bg'
              } else {
                bgSelector = 'data-xs-bg'
              }
            } else {
              bgSelector = 'data-xs-bg'
            }
          }

          if (viewport.is('md')) {
            if ($('#masthead').children('.inner').attr('data-md-bg')) {
              if ($('#masthead').children('.inner').attr('data-md-bg') !== '') {
                bgSelector = 'data-md-bg'
              } else {
                if ($('#masthead').children('.inner').attr('data-sm-bg')) {
                  if ($('#masthead').children('.inner').attr('data-sm-bg') !== '') {
                    bgSelector = 'data-sm-bg'
                  } else {
                    bgSelector = 'data-xs-bg'
                  }
                } else {
                  bgSelector = 'data-xs-bg'
                }
              }
            } else {
              if ($('#masthead').children('.inner').attr('data-sm-bg')) {
                if ($('#masthead').children('.inner').attr('data-sm-bg') !== '') {
                  bgSelector = 'data-sm-bg'
                } else {
                  bgSelector = 'data-xs-bg'
                }
              } else {
                bgSelector = 'data-xs-bg'
              }
            }
          }

          if (viewport.is('lg')) {
            if ($('#masthead').children('.inner').attr('data-lg-bg')) {
              if ($('#masthead').children('.inner').attr('data-lg-bg') !== '') {
                bgSelector = 'data-lg-bg'
              } else {
                if ($('#masthead').children('.inner').attr('data-md-bg')) {
                  if ($('#masthead').children('.inner').attr('data-md-bg') !== '') {
                    bgSelector = 'data-md-bg'
                  } else {
                    if ($('#masthead').children('.inner').attr('data-sm-bg')) {
                      if ($('#masthead').children('.inner').attr('data-sm-bg') !== '') {
                        bgSelector = 'data-sm-bg'
                      } else {
                        bgSelector = 'data-xs-bg'
                      }
                    } else {
                      bgSelector = 'data-xs-bg'
                    }
                  }
                } else {
                  if ($('#masthead').children('.inner').attr('data-sm-bg')) {
                    if ($('#masthead').children('.inner').attr('data-sm-bg') !== '') {
                      bgSelector = 'data-sm-bg'
                    } else {
                      bgSelector = 'data-xs-bg'
                    }
                  } else {
                    bgSelector = 'data-xs-bg'
                  }
                }
              }
            } else {
              if ($('#masthead').children('.inner').attr('data-md-bg')) {
                if ($('#masthead').children('.inner').attr('data-md-bg') !== '') {
                  bgSelector = 'data-md-bg'
                } else {
                  if ($('#masthead').children('.inner').attr('data-sm-bg')) {
                    if ($('#masthead').children('.inner').attr('data-sm-bg') !== '') {
                      bgSelector = 'data-sm-bg'
                    } else {
                      bgSelector = 'data-xs-bg'
                    }
                  } else {
                    bgSelector = 'data-xs-bg'
                  }
                }
              } else {
                if ($('#masthead').children('.inner').attr('data-sm-bg')) {
                  if ($('#masthead').children('.inner').attr('data-sm-bg') !== '') {
                    bgSelector = 'data-sm-bg'
                  } else {
                    bgSelector = 'data-xs-bg'
                  }
                } else {
                  bgSelector = 'data-xs-bg'
                }
              }
            }
          }

          if ($('#masthead').children('.inner').attr(bgSelector)) {
            bgImage = $('#masthead').children('.inner').attr(bgSelector)
          }

          $('#masthead').children('.inner').css(
            'background-image', 'url(' + bgImage + ')'
          )
        }

        /**
        * ------------------------
        * Stuff to do on page load
        * ------------------------
        */

        (function ($, viewport) {
          responsiveHeroImage(viewport)

          // Execute code each time window size changes
          $(window).resize(
            viewport.changed(function () {
              responsiveHeroImage(viewport)
            })
          )
        })(jQuery, ResponsiveBootstrapToolkit)

        /**
        * All drodwon menus across the site
        */

        $('select').each(function () {
          if ($(this).children('option').length > 5 || $(this).hasClass('activate-chosen')) {
            $(this).chosen({
              width: '100%'
            })
          }
        })

        /**
        * Keyboard shortcut for opening quick search form
        */
        Mousetrap.bind(['command+shift+s', 'ctrl+shift+s'], function (e) {
          if ($('#quicker-quick-search').hasClass('opened')) {
            $('#quicker-quick-search').fadeOut(400, function () {
              $('#quicker-quick-search').removeClass('opened')
            })
          } else {
            $('#quicker-quick-search').fadeIn(400, function () {
              $('#quicker-quick-search').addClass('opened')

              $('#quicker-quick-search input').focus()
            })
          }

          return false
        })

        $('.close-window-now').on('click', function (e) {
          if ($('#quicker-quick-search').hasClass('opened')) {
            e.preventDefault()
            $('#quicker-quick-search').fadeOut(400, function () {
              $('#quicker-quick-search').removeClass('opened')
            })
          }
        })

        // Handle checkout button click events, show a loading icon and set to disable so customer cannot click multiple times
        const $checkoutButton = $('.checkout-button, .confirm-booking-button')
        $checkoutButton.on('click', function () {
          // Keep the same width so the button doesn't jump around
          $(this).width($(this).width())

          $(this).css({
            opacity: 0.8,
            pointerEvents: 'none',
            cursor: 'default'
          })
          $(this).html('<i class="fa fa-refresh fa-spin fa-fw"></i>')
        })

        /**
         * Handles the floor plans functionality.
         * Finds all elements with class "view-floor-plans" and assigns them a click event listener.
         * When clicked, it shows the floor plan modal.
         */
        const handleFloorPlans = () => {
          /**
           * Show the Floor Plan Modal
           *
           * @param {Object} $modal jQuery object of the modal
           * @param {Number} selectedIndex Selected index of the image
           * @param {Array} images Array of images
           * @param {String} disclaimer Disclaimer text
           */
          const showContent = ($modal, selectedIndex, images, disclaimer) => {
            const $content = $modal.find('.modal-body_content')
            let bodyHtml = ''

            // Loop through each image and add it to the carousel
            for (const [index, element] of images.entries()) {
              const imageSrc = element.imgUrl
              const imageAlt = `Floor Plan ${index + 1}`
              const imageHeight = 600

              // Add the image to the carousel (using slick)
              bodyHtml += `
                    <div class="image-container" style="height: ${imageHeight}px; width: 100%;">
                      <img src="${imageSrc}" alt="${imageAlt}" style="width: 100%; height: 100%; object-fit: contain;">
                      <div class="disclaimer text-muted">
                        <i class="fa fa-info-circle"></i>
                        ${disclaimer}
                      </div>
                      <h3 class="caption">Floor Plan ${index + 1}</h3>
                    </div>
                  `
            }

            // Set the html of the carousel
            $content.empty()
            $content.html(bodyHtml)

            // Set the modal content
            $modal.find('.modal-body').append($content)

            // Initialise the carousel
            $content.slick({
              dots: false,
              arrows: true,
              infinite: true,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: selectedIndex,
              adaptiveHeight: false,
              centerMode: true,
              centerPadding: 0,
              responsive: [
                {
                  // Below Desktop, remove the arrows and center mode
                  breakpoint: 992,
                  settings: {
                    arrows: false,
                    centerMode: false,
                    variableWidth: false
                  }
                }
              ]
            })

            // Remove the slick instance when the modal is hidden
            $modal.on('hidden.bs.modal', function () {
              $content.slick('unslick')
            })
          }

          $('body').on('click', '.view-floor-plans', function () {
            const propertyCode = $(this).data('property-code')

            const $modal = createModal(`Floor Plan (${propertyCode})`, `
              <div class="modal-body_content">
                <div class="modal-body_loader"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div>
              </div>
            `, {
              class: 'floorplans-modal',
              size: 'lg'
            })

            const propertyId = $(this).data('property-id')
            const selectedIndex = $(this).data('selected-index') || 0

            $.ajax({
              url: `/ajax/villa/floor-plans/${propertyId}`,
              success: function (data) {
                showContent($modal, selectedIndex, data.images, data.disclaimer)
              },
              error: function () {
                $modal.modal('hide')

                createAlert('Error Occured', 'An error occured while trying to load the floor plans.', {
                  alertType: 'danger'
                })
              }
            })
          })
        }

        handleFloorPlans()

        const $topBanner = $('.top-banner')
        if ($topBanner.hasClass('christmas-banner')) {
          // We don't want to run this on mobile since it's not visible
          if ($(window).width() > 1024) {
            const snowFlakes = new Snowflakes({
              container: document.querySelector('body'),
              count: 50,
              color: '#fff',
              zIndex: -1
            })

            snowFlakes.start()
          }
        }

        const handlePopUpOfferModal = () => {
          const $modal = $('#pop-up-offer-modal')

          if ($modal.length) {
            // Check to see if the browser supports local storage
            if (typeof (Storage) === 'undefined') {
              return
            }

            const localStorageKey = $modal.data('local-storage-dismiss-key')
            const localStorageValue = localStorage.getItem(localStorageKey)

            if (localStorageValue === null) {
              $modal.modal('show')

              localStorage.setItem(localStorageKey, true)
            }
          }
        }

        handlePopUpOfferModal()
      }
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
        /**
        * -------------------------------
        * Functions that we will be using
        * -------------------------------
        */

        /**
        * Jumpstarting Slick
        * @param state
        */
        function goGoSlick(state) {
          if (state === 'start') {
            $('.homepage-carousel').slick({
              lazyLoad: 'ondemand',
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              autoplay: true,
              autoplaySpeed: 5000,
              dots: true,
              fade: true,
              cssEase: 'linear',
              pauseOnFocus: false,
              pauseOnHover: false,
              rows: 0
            })
          }

          if (state === 'stop') {
            $('.homepage-carousel').slick('unslick')
          }
        }

        // Slick is currently not active
        let slickActive = false

        /**
        * Debounce progress bar
        * @type {Function}
        */
        const carouselResize = debounce(function () {
          // If window width is less than the minimum breakpoint, activate or update Slick
          // Else, deactivate if active
          if ($(window).width() >= 768) {
            // If Slick is not active, initialize Slick and set slickActive to true.
            if (!slickActive) {
              goGoSlick('start')
              slickActive = true
            }
          } else {
            // If Slick is active, deactivate it, and update SlickActive to false.
            if (slickActive) {
              goGoSlick('stop')
              slickActive = false
            }
          }
        }, 150)

        window.addEventListener('resize', carouselResize)

        /**
        * =============================
        * Things to do on window resize
        * =============================
        */
        const windowResize = debounce(function () {
          /**
          * Homepage newsletter box
          */
          $.fn.matchHeight._update()
        }, 250) // end of debounce function

        window.addEventListener('resize', windowResize)

        /**
        * =========================
        * Things to do on page load
        * =========================
        */

        /**
        * Slick carousel
        */
        // If the window width is less than our minimum breakpoint. Initialize Slick and set slickActive to true.
        // Else, keep slick turned off
        if ($(window).width() >= 768) {
          goGoSlick('start')
          slickActive = true
        }

        /**
        * Homepage newsletter box
        */
        $('.debbies_sameheight').matchHeight()
      }
    },

    flights: {
      init: function () {
        $('#flight-terms-modal').on('show.bs.modal', function (e) {
          $('#flight-terms-modal .modal-body-terms').html('<div class="row"><div class="col-xs-12 text-center" style="line-height:200px;"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div></div>')
          const $link = $('#flight-terms-link')
          const _url = $link.data('terms-url')
          const _quoteId = $link.data('quote-id')
          const _correlationId = $link.data('correlation-id')
          const _flightSearchId = $link.data('flight-search-id')
          const _flightSelectedFare = $link.data('flight-selected-fare')
          const _supplierId = $link.data('supplier-id')
          $.ajax({
            type: 'POST',
            url: _url,
            data: {
              correlationId: _correlationId,
              quoteId: _quoteId,
              flightSearchId: _flightSearchId,
              flightSelectedFare: _flightSelectedFare,
              supplierId: _supplierId
            },
            cache: false,
            success: function (response) {
              const oResponse = $.parseJSON(response)
              $('#flight-terms-modal .modal-body-terms').html(oResponse.body)
            },
            error: function () {
              $('#flight-terms-modal .modal-body-terms').html(`
                <hr/>
                <div class="row">
                  <div class="col-xs-12 text-center" style="display:flex;justify-content:center;align-items:center;line-height:100px;">
                  <i class="fa fa-exclamation-triangle fa-3x fa-fw" style="color:#ffc107;"></i> Error loading terms and conditions.
                  </div>
                </div>`
              )
            }
          })
        })
      }
    },
    flights_search_form: {
      init: function () {
        const setEarliestAndLatestAsTheDateThatIsPreFilledIfDatesNotEditable = function () {
          const arrivalOrDeparture = ['arrival', 'departure']
          for (const i in arrivalOrDeparture) {
            const arriveOrDepart = arrivalOrDeparture[i]
            const $arriveOrDepartField = $('#' + arriveOrDepart)
            if ($arriveOrDepartField.hasClass('datesNotEditable')) {
              // hack to make the field essentially disabled
              // https://github.com/amsul/pickadate.js/issues/982
              $arriveOrDepartField.off('click focus')
            }
          }
        }

        setEarliestAndLatestAsTheDateThatIsPreFilledIfDatesNotEditable()

        const setFlightsFormVisible = function () {
          if ($('#with_flights').length) { // only hide the flights form if its part of the villa search form - else its a standalone form on the flights page
            const flightsFormVisible = $('#with_flights').val()
            if (flightsFormVisible == '1') {
              $('#search_form_button_main').addClass('hidden')
              $('#flightsForm').removeClass('hidden')
              $('#flightsFormFieldset').prop('disabled', false)
            } else {
              $('#search_form_button_main').removeClass('hidden')
              $('#flightsForm').addClass('hidden')
              $('#flightsFormFieldset').prop('disabled', 'disabled')
            }
          }
        }

        const setIncludeCarHireOptionsVisible = function () {
          if ($('#include_car_hire').length) {
            // this will be thr standalone flights form
            const carHireOptionsVisible = $('#include_car_hire').val()
            if (carHireOptionsVisible == '1') {
              $('#includeCarHireLeadDriverInfo').removeClass('hidden')
            } else {
              $('#includeCarHireLeadDriverInfo').addClass('hidden')
            }
          }
        }

        const setChildrenAgesVisible = function () {
          const childrenCount = parseInt($('#children').val(), 10)
          if (childrenCount > 0) {
            $('#childrenAges').removeClass('hidden')
          } else {
            $('#childrenAges').addClass('hidden')
          }
          if (childrenCount == 4) {
            $('#visibleWith4ChildrenSelected').removeClass('hidden')
          } else {
            $('#visibleWith4ChildrenSelected').addClass('hidden')
          }
          for (let i = 1; i <= 9; i++) {
            const $childFormAgeElement = $('#child_age_form_' + i)
            const $childAgeSelectElement = $('#child_age_' + i)
            if (i > childrenCount) {
              $childFormAgeElement.addClass('hidden')
              $childAgeSelectElement.prop('disabled', 'disabled') // we dont want these additional empty child ages submitted in the get query string
            } else {
              $childFormAgeElement.removeClass('hidden')
              $childAgeSelectElement.prop('disabled', false)
            }
          }
        }

        const destroyFlightsFormTooltipErrors = function () {
          $('#flightsForm *').filter(':input, .tooltip-area').each(function () {
            $(this).tooltip('destroy')
          })
        }

        const displayFlightsErrorModal = function (title, body) {
          $('#flightsErrorModal').find('#flightsErrorModalTitle').html(title)
          $('#flightsErrorModal').find('#flightsErrorModalBody').html(body)
          $('#flightsErrorModal').modal('show')
        }

        const displayGroupBookingWarning = function () {
          const modalTitle = 'Group Booking (10 or more passengers)'
          const modalBody = '<p>Unfortunately, we are only able to process an online booking for up to 9 passengers.</p><p>For groups of 10 or more passengers, please call us on 01892 836822 and one of our travel consultants will be happy to help.</p>'
          displayFlightsErrorModal(modalTitle, modalBody)
        }

        displayNoFlightResultsWarning = function () { // var defined in outer scope.
          const modalTitle = 'No Flight Results'
          const modalBody = '<p>Unfortunately, we do not have any flights available for your current search criteria, you can try alternative dates, airports, cabin classes or direct / non-direct.</p><p>If you are travelling less than 18 months away, we can still help find the perfect flight for you by contacting the airlines on your behalf.  Firstly, please find your preferred villa online by using the Search facility and then either give us a call or drop us an email and we will do the rest for you.</p>'
          displayFlightsErrorModal(modalTitle, modalBody)
        }

        const checkIfNoFlightSearchResults = function () {
          const hasNoFlightResults = $('#flightsFormFieldset').data('noFlightResults') ? 1 : 0
          return hasNoFlightResults
        }

        const hasNoFlightResults = checkIfNoFlightSearchResults()
        if (hasNoFlightResults) {
          displayNoFlightResultsWarning()
        }

        const displayGreaterThanCanBeBookInTheFutureWarning = function () {
          const maximumReturnDate = $('#flightsFormFieldset').data('latestDateToReturn')
          const formattedMaximumReturnDate = moment(maximumReturnDate, 'YYYY-MM-DD').format(('ddd Do MMMM YYYY'))
          const modalTitle = 'Flights not currently available for your dates'
          const modalBody = '<p>We’re sorry; we are unable to return online flight results for your dates at the moment because flight details may not have been released by the airlines yet.</p><p>If you are travelling less than 18 months away, we can still help find the perfect flight for you by contacting the airlines on your behalf.  Firstly, please find your preferred villa online by using the Search facility and then either give us a call or drop us an email and we will do the rest for you.</p>'
          displayFlightsErrorModal(modalTitle, modalBody)
        }

        const checkIfPassengerCountIsAGroupBooking = function () {
          const adultCount = parseInt($('#adults').val(), 10)
          const childrenCount = parseInt($('#children').val(), 10)
          const infantCount = parseInt($('#infants').val(), 10)
          const totalPassengerCount = adultCount + childrenCount + infantCount
          if (totalPassengerCount > 9) {
            return true
          }
          return false
        }

        const checkDateIsGreaterThanMaximumBookingDaysInTheFuture = function () {
          const latestDateToReturn = $('#flightsFormFieldset').data('latestDateToReturn')
          const isPartOfVillaSearchForm = $('#with_flights').length
          let returnDate
          if (isPartOfVillaSearchForm) {
            const nights = $('#nights').val()
            const arrivalDate = moment($('#arrival').val(), 'DD-MM-YYYY')
            returnDate = arrivalDate.clone().add(nights, 'days').format('YYYY-MM-DD')
          } else {
            // standalone flights form
            returnDate = moment($('#departure').val(), 'DD-MM-YYYY').format('YYYY-MM-DD')
          }

          const maximumReturnDate = moment(latestDateToReturn, 'YYYY-MM-DD')
          const actualReturnDate = moment(returnDate, 'YYYY-MM-DD')

          if (actualReturnDate.isAfter(maximumReturnDate)) {
            return true
          } else {
            return false
          }
        }

        checkDateIsGreaterThanMaximumBookingDaysInTheFuture()

        $('#flight_from, #flight_to, #adults, #children, #infants, #cabin_class, #direct_only, .childAgeSelects, #include_car_hire, #source_country').on('chosen:showing_dropdown chosen:hiding_dropdown', function () {
          destroyFlightsFormTooltipErrors()
        })

        $('#arrival, #departure, #flight_from, #flight_to, #driver_age').on('change', function () {
          destroyFlightsFormTooltipErrors()
        })

        $('#arrival, #departure, #flight_from_search, #flight_to_search, #driver_age').on('focus', function () {
          destroyFlightsFormTooltipErrors()
        })

        $('#with_flights').on('change', function () {
          setFlightsFormVisible()
          destroyFlightsFormTooltipErrors()
        })

        $('#include_car_hire').on('change', function () {
          setIncludeCarHireOptionsVisible()
          destroyFlightsFormTooltipErrors()
        })

        $('#children').on('change', function () {
          setChildrenAgesVisible()
        })

        // $('#adults, #children, #infants').on('change', function(){
        //   checkPassengerCountIsNotAGroupBooking();
        // });

        setFlightsFormVisible()
        setChildrenAgesVisible()
        setIncludeCarHireOptionsVisible()
        // checkPassengerCountIsNotAGroupBooking();

        $('#date-and-nights-search-form, #flights-standalone-search-form').on('submit', function (evt) { // forms are used in two different places with 2 different ids - home + properties is combined with villa - then checkout/flights is the standalone version
          // set by default no errors - form will submit
          let formError = false
          const isPartOfVillaSearchForm = $('#with_flights').length
          let hasFlights = true
          if (isPartOfVillaSearchForm && $('#with_flights').val() != '1') {
            hasFlights = false
          }

          // validate the values and make sure they are all filled out.
          if (hasFlights) {
            // it has flights

            // check flying from and to are set
            const ways = ['from', 'to']
            let way
            for (var i in ways) {
              way = ways[i]
              var id = '#flight_' + way
              if (!$(id).val()) {
                formError = true
                var toolTipAreaId = '#flight_' + way + '_tooltipArea'
                $(toolTipAreaId).tooltip({
                  placement: 'bottom',
                  title: 'Please select where flying ' + way,
                  trigger: 'manual'
                })
                $(toolTipAreaId).tooltip('show')
              }
            }

            // check dates are filled out if dates are part of the form
            const arrivalOrDeparture = ['arrival', 'departure']
            for (var i in arrivalOrDeparture) {
              var id = '#' + arrivalOrDeparture[i]
              if ($(id).length) {
                if (!$(id).val()) {
                  formError = true
                  $(id).tooltip({
                    placement: 'bottom',
                    title: 'Please select a date',
                    trigger: 'manual'
                  })
                  $(id).tooltip('show')
                }
              }
            }

            // check number of adults are set
            if (!$('#adults').val() || $('#adults').val() == '0') { // adults must also be greater than 0
              formError = true
              var toolTipAreaId = '#adults_tooltipArea'
              $(toolTipAreaId).tooltip({
                placement: 'bottom',
                title: 'Please select the number of adults',
                trigger: 'manual'
              })
              $(toolTipAreaId).tooltip('show')
            }

            // check cabin class is set
            if (!$('#cabin_class').val()) {
              formError = true
              var toolTipAreaId = '#cabin_class_tooltipArea'
              $(toolTipAreaId).tooltip({
                placement: 'bottom',
                title: 'Please select the cabin class',
                trigger: 'manual'
              })
              $(toolTipAreaId).tooltip('show')
            }

            // check if direct flights only is set
            if (!$('#direct_only').val()) {
              formError = true
              var toolTipAreaId = '#direct_only_tooltipArea'
              $(toolTipAreaId).tooltip({
                placement: 'bottom',
                title: 'Please select if you want direct only flights',
                trigger: 'manual'
              })
              $(toolTipAreaId).tooltip('show')
            }

            const includeCarHire = ($('#include_car_hire').val() == 1)
            if (includeCarHire) {
              // check if age entered of the driver is correct
              const driverAgeValue = $('#driver_age').val()
              const driverAgeErrorTooltip = checkCarHireDriverAgeSetCorrectly(driverAgeValue)

              if (driverAgeErrorTooltip != '') {
                formError = true
                $('#driver_age').tooltip({
                  placement: 'bottom',
                  title: driverAgeErrorTooltip,
                  trigger: 'manual'
                })
                $('#driver_age').tooltip('show')
              }

              // check source_country is set
              if (!$('#source_country').val()) {
                formError = true
                var toolTipAreaId = '#source_country_tooltipArea'
                $(toolTipAreaId).tooltip({
                  placement: 'bottom',
                  title: 'Please select the Lead driver\'s country of residence',
                  trigger: 'manual'
                })
                $(toolTipAreaId).tooltip('show')
              }
            }
            // return false

            let childrenCount = 0
            if ($('#children').val()) {
              childrenCount = parseInt($('#children').val(), 10)
            }
            if (childrenCount > 0) {
              // make sure all child ages are filled out.
              for (var i = 1; i <= childrenCount; i++) {
                const childAgeElementId = '#child_age_' + i
                const childAgeToolTipAreaId = childAgeElementId + '_tooltipArea'
                if (!$(childAgeElementId).val()) {
                  formError = true
                  $(childAgeToolTipAreaId).tooltip({
                    placement: 'bottom',
                    title: 'Please enter the age of child ' + i,
                    trigger: 'manual'
                  })
                  $(childAgeToolTipAreaId).tooltip('show')
                }
              }
            }
            if (!formError) {
              // check if total passengers > 9
              const isGroupBooking = checkIfPassengerCountIsAGroupBooking()
              if (isGroupBooking) {
                formError = true
                displayGroupBookingWarning()
              }
            }

            if (!formError) {
              // check if return date is greater than maximum bookable days into the future.
              const dateIsGreaterThanMaximumBookingDaysIntoTheFuture = checkDateIsGreaterThanMaximumBookingDaysInTheFuture()
              if (dateIsGreaterThanMaximumBookingDaysIntoTheFuture) {
                formError = true
                displayGreaterThanCanBeBookInTheFutureWarning()
              }
            }
          } // end hasFlights

          if (formError) {
            evt.preventDefault() // stops the form submitting
          } else {
            // submit the form
            // set children and infants to 0 if values not set
            const passengerTypes = ['children', 'infants']
            for (var i in passengerTypes) {
              const passengerType = passengerTypes[i]
              const chosenElementId = '#' + passengerType
              if (!$(chosenElementId).val()) {
                $(chosenElementId).val(0)
                $(chosenElementId).trigger('chosen:updated')
              }
            }
            $('.search-villas-and-flights-button').html('<i class="fa fa-refresh fa-spin fa-fw"></i>').attr('disabled', true)
          }
        })
      }
    },
    flights_search_form_results: {
      init: function () {
        const sections = []

        function Section($section) {
          this.id = $section.data('id')
          this.$section = $section
          this.isChosen = $section.hasClass('section--included')
          this.$bounds = this.$section.find('.bound')
          this.bounds = []
          this.visible = false
          this.$showMore = this.$section.find('.show-more')
          this.$selectFlight = this.$section.find('.select-flight')

          const $this = this

          // Toggle section to show all options
          $this.toggle = function () {
            $this.show($this.visible = !$this.visible)
          }

          // Close section to hide all options except selected option
          $this.close = function () {
            $this.show($this.visible = false)
          }

          $this.show = function (visible) {
            // Go through each bound and show/hide it
            for (let i = 0; i < $this.bounds.length; i++) {
              if (i === $this.bounds[i].id) {
                $this.bounds[i].show(visible)
              }
            }

            // Update Text
            if (visible) {
              $this.$showMore.text('Less Flight Times')
              $this.$section.addClass('section-focus')
            } else {
              $this.$showMore.text('More Flight Times')
              $this.$section.removeClass('section-focus')
            }
          }

          $this.updateUrl = function (boundId) {
            const searchParams = new URLSearchParams(window.location.search)
            const bound = $this.bounds[boundId].selectedOption
            const boundKey = boundId === 0 ? 'flightSelectedOutBoundOption' : 'flightSelectedInBoundOption'

            // Update url
            searchParams.set(boundKey, bound.id)

            const selectedFare = UTIL.getUrlParameter('flightSelectedFare')

            // Set seleced fare, in order for out options to correctly work
            if (!selectedFare) {
              searchParams.set('flightSelectedFare', $this.id)
            }

            const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString()
            history.pushState(null, '', newRelativePathQuery)

            const $viewVillaDetailsButtons = $('.view-villa-details')

            // Loop through view villa details button, and update href boundkey with new id
            $viewVillaDetailsButtons.each(function () {
              const $viewVillaDetailsButton = $(this)
              let href = $viewVillaDetailsButton.attr('href')
              if (boundKey === 'flightSelectedOutBoundOption') {
                href = href.replace(/flightSelectedOutBoundOption=[0-9]+/, 'flightSelectedOutBoundOption=' + bound.id)
              } else {
                href = href.replace(/flightSelectedInBoundOption=[0-9]+/, 'flightSelectedInBoundOption=' + bound.id)
              }

              $viewVillaDetailsButton.attr('href', href)
            })
          }

          // Show/hide options in section
          $this.$showMore.on('click', function () {
            // Close other sections
            Object.keys(sections).forEach(function (key) {
              if (sections[key].id !== $this.id) {
                sections[key].close()
              }
            })

            $this.toggle()
          })

          $this.$selectFlight.on('click', function () {
            // Get selected option
            const outbound = $this.bounds[0].selectedOption
            const inbound = $this.bounds[1].selectedOption

            const url = $this.$selectFlight.data('url')

            // Don't show modal on villa search page and villa info page
            if (!$('.villa-search-form').length && !$('.villa-info').length) {
              // Create a place holder to show we are loading the flight quote
              const contentHtml = `
                <div class="loading-flights">
                  <div class="loading-flights_content">
                    <div class="loading-flights_icon">
                      <img src="/dist/images/flights/aircraft.svg" alt="Aircraft"/>
                    </div>
                    <div class="loading-flights_text">
                      <h3>Finalising your quote</h3>
                      <p>Please wait while we are finalising your quote.</p>
                    </div>
                  </div>
                </div>
              `

              createModal('', contentHtml, {
                showHeader: false,
                showFooter: false,
                disableBackdrop: true
              })
            }

            $this.$selectFlight.html('<i class="fa fa-refresh fa-spin fa-fw"></i>')
            $this.$selectFlight.attr('disabled', true)

            window.location.href = url + '&flightSelectedOutBoundOption=' + outbound.id + '&flightSelectedInBoundOption=' + inbound.id
          })

          // Initialize inbound/outbound
          $this.$bounds.each(function (index) {
            $this.bounds.push(new Bound(index, $(this), $this))
          })

          return $this
        }

        function Option($option, bound) {
          this.id = $option.data('id')
          this.$option = $option
          this.bound = bound
          this.selected = false

          const $this = this

          $this.setSelected = function (selected, updateUrl = true) {
            if (selected) {
              Object.keys($this.bound.options).forEach(function (key) {
                $this.bound.options[key].setSelected(false)
              })

              $this.selected = true
              $this.$option.addClass('option-selected')
              $this.$option.removeClass('option-hidden')
              $this.$option.find('input[type="radio"]').prop('checked', true)

              // For quicker reference
              $this.bound.selectedOption = $this

              if ($this.bound.section.isChosen && updateUrl) {
                // Update URL so we can keep track which option we have selected
                $this.bound.section.updateUrl($this.bound.id)
              }

              if ($this.bound.section.isChosen) {
                const $includedSections = $('.section--included')

                if ($includedSections.length > 1) {
                  const $includedSection = $includedSections.last()
                  const $bounds = $includedSection.find('.bound')
                  const $bound = $this.bound.id === 0 ? $bounds.first() : $bounds.last()
                  const $option = $bound.find('.option').first()

                  $option.html($this.$option.html())

                  $option.find('input').remove()
                }
              }

              // Close the section
              $this.bound.section.close()
            } else {
              $this.selected = false
              $this.$option.removeClass('option-selected')
              $this.$option.find('input[type="radio"]').prop('checked', false)
            }
          }

          // Show Option
          $this.show = function (visible) {
            if (visible) {
              $this.$option.removeClass('option-hidden')
              $this.$option.addClass('option-visible')
              $this.$option.find('input[type="radio"]').removeClass('departure-radio-hidden')
            } else {
              // If option is selected, don't hide it
              if (!$this.selected) {
                $this.$option.addClass('option-hidden')
              }

              $this.$option.removeClass('option-visible')

              $this.$option.find('input[type="radio"]').addClass('departure-radio-hidden')
            }
          }

          $this.$option.on('click', function () {
            if (!$(this).hasClass('option-visible')) {
              return
            }

            $this.setSelected(true)
            // Set radio button to check
            $this.$option.find('input[type="radio"]').prop('checked', true)
          })

          // Listen for the radio button being checked
          $this.$option.find('input[type="radio"]').on('change', function (e) {
            e.stopPropagation()
            $this.setSelected(true)
          })

          return $this
        }

        function Bound(id, bound, section) {
          this.id = id
          this.$bound = bound
          this.section = section
          this.options = [] // Options inside the bound
          this.selectedOption = {} // For quick reference

          const $this = this

          // Show all options
          $this.show = function (visible) {
            Object.keys($this.options).forEach(function (key) {
              $this.options[key].show(visible)
            })
          }

          // Initialize options
          $this.$bound.find('.option').each(function (index) {
            $this.options[$(this).data('id')] = new Option($(this), $this)
          })

          // Set first option to be default selected
          $this.selectedOption = Object.entries($this.options)[0][1]
          Object.entries($this.options)[0][1].setSelected(true, false)

          return $this
        }

        // If sections already exist, then delete them from the heap
        if (Object.keys(sections).length > 0) {
          Object.keys(sections).forEach(function (key) {
            delete sections[key]
          })
        }

        // Store sections, except included sections
        $('.section').not('.section--included').each(function () {
          sections[$(this).data('id')] = new Section($(this))
        })

        if ($('.section--included').length) {
          const $includedSection = $('.section--included').first()
          sections[$includedSection.data('id')] = new Section($includedSection)
        }

        const flightSelectedFare = UTIL.getUrlParameter('flightSelectedFare')

        if (flightSelectedFare) {
          const includedSection = sections[flightSelectedFare]

          if (includedSection) {
            Object.keys(includedSection.bounds).forEach(function (key) {
              const bound = includedSection.bounds[key]
              const option = UTIL.getUrlParameter(bound.id === 0 ? 'flightSelectedOutBoundOption' : 'flightSelectedInBoundOption')

              if (bound.options[option]) {
                bound.options[option].setSelected(true)
              }
            })
          }
        }

        // Show Itinerary modal
        const $modal = $('#flight-itinerary-modal')
        // Remove any existing event listeners as this function is called again when selecting a filter/calendar etc...
        $modal.off('show.bs.modal')

        $modal.on('show.bs.modal', function (e) {
          const section = sections[$(e.relatedTarget).closest('.section').data('id')]

          // Loader
          $modal.find('.modal-body-content').html('<div class="modal-body_loader"><i class="fa fa-refresh fa-spin fa-fw"></i></div>')

          // NOTE; It's easier to build the modal on the server (take advantage of template system)
          // than building the modal on front end
          $.ajax({
            url: '/flights/itinerary',
            method: 'POST',
            data: {
              flightSearchId: $('.flight-search-results').data('flight-search-id'),
              selectedFare: section.id,
              outboundOptionId: section.bounds[0].selectedOption.id,
              inboundOptionId: section.bounds[1].selectedOption.id
            },
            success: function (data) {
              $modal.find('.modal-body-content').html(data)
            },
            error: function () {
              $modal.find('.modal-body-content').html('<p>Something went wrong. Please try again.</p>')
            }
          })
        })

        analyticsEvent('view_flights')
      }
    },
    // About us page, note the change from about-us to about_us.
    villas: {
      init: function () {
        $('input:checkbox').each(function () {
          if ($(this).data('is-indeterminate') == 1) {
            this.indeterminate = true
          }
        })
        // JavaScript to be fired on the villas page

        /**
        * Date selector carousel
        */
        const breakpoints = {
          small: 560,
          medium: 767
        }

        const setUpFlexibleDatesSlick = function () {
          $('.date-selector').slick({
            arrows: false,
            slidesToShow: 7,
            infinite: false,
            slidesToScroll: 7,
            initialSlide: 0,
            dots: false,
            slide: 'a',
            rows: 0,
            responsive: [
              {
                breakpoint: breakpoints.medium,
                settings: {
                  slidesToShow: 5,
                  slidesToScroll: 1,
                  initialSlide: 1
                }
              },

              {
                breakpoint: breakpoints.small,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  initialSlide: 2
                }
              }
            ]
          })
        }

        setUpFlexibleDatesSlick()

        /**
        * =============================
        * Things to do on window resize
        * =============================
        */

        const resizeSlickAndChangeSlide = function () {
          const currentSlide = $('.date-selector').slick('slickCurrentSlide')
          if ($(window).width() > breakpoints.medium) {
            if (currentSlide !== 0) {
              $('.date-selector').slick('slickGoTo', 0)
            }
          }

          if (($(window).width() <= breakpoints.medium) && ($(window).width() > breakpoints.small)) {
            if (currentSlide !== 1) {
              $('.date-selector').slick('slickGoTo', 1)
            }
          }

          if ($(window).width() <= breakpoints.small) {
            if (currentSlide !== 2) {
              $('.date-selector').slick('slickGoTo', 2)
            }
          }
        }

        $(window).on('resize', function (e) {
          resizeSlickAndChangeSlide()
        })

        const resetSlick = function () {
          $('.date-selector').slick('unslick')
          setUpFlexibleDatesSlick()
        }

        /**
        * =============================
        * live filters
        * =============================
        */

        $(window).on('popstate', function (e) {
          filterVillas(history.state)
        })

        let flightSearchButtonNeedsPressing = false

        const updateVillas = function (jsonResults) {
          flightSearchButtonNeedsPressing = false // reseet the flightSearchButtonNeedsPressing so we can ajax change dates and nights again - this flag tells us we need to press the search button instead of ajax searching.
          const results = $.parseJSON(jsonResults)
          $('.search-results').fadeOut(200, function () {
            $('.search-results').html(results.searchResults)
            $('.search-results').fadeIn(400, function () {
              setupSearchResultsCarousel()
            })
          })

          // Remove spinner icon and set opacity back to 1
          $('#with_flights_label').find('.fa').remove()
          $('#with_flights').closest('.form-group').css('opacity', 1)
          $('#with_flights').attr('disabled', false)

          $('.clear-button, .search-villas-button').html('Show ' + results.totalFound + ' villa' + (results.totalFound > 1 ? 's' : ''))

          if (results.totalFound > 0) {
            $('.pagination-holder').html(results.paginationHTML)
            $('.pagination-container .result-total').html(results.chooseFromMessage)
            $('.pagination-container').fadeTo(null, 1)
          } else {
            $('#no-results-text-area .error-message h2').html(results.noResultsText.heading)
            $('#no-results-text-area .error-message p').html(results.noResultsText.paragraph)
            $('#no-results-text-area').fadeIn()
          }

          $('#pageMainH1Area').html('<h1>' + results.pageMainH1 + '</h1>')
          if (results.landingPageCopy !== false) {
            $('#landingPageCopy').html(results.landingPageCopy)
            $('#landingPageCopy').fadeIn()
            $('#pageMainH1Area').fadeOut()
          } else {
            $('#landingPageCopy').fadeOut()
            $('#pageMainH1Area').fadeIn()
          }
          createReadMoreLandingPageCopy()
          if (results.pageTitle) {
            document.title = results.pageTitle
          }

          // either open the flexible dates container or hide it if we toggle back to villas page without dates searched
          if (results.dateSearched) {
            if ($('.date-select-container').css('display') == 'none') {
              $('.date-select-container').fadeIn()
              resetSlick()
            }
          } else {
            $('.date-select-container').fadeOut()
            $('.search-form').data('search-performed', false)
          }

          if (results.dateSearched) {
            $('#arrival').data('dontlistenonset', true) // setting the value to the value searched sets the date pickers on change event which fires filtering again - so add this attribute and ignore the change event the first time and remove this param
            const dateSelected = moment(results.dateSearched)
            $('#arrival').pickadate('picker').set('select', dateSelected.toDate())
          }

          if (results.nights) {
            $('#nights').val(results.nights)
            $('#nights').trigger('chosen:updated')
          }

          if (results.filterHTML) {
            $('#responsiveSearchFilter').replaceWith(results.filterHTML)
          }

          //
          // if(results.hasFlights){
          //   $('#with_flights').val(1);
          // } else {
          //   $('#with_flights').val(0);
          //   $('#with_flights').trigger("change");
          // }

          // update the datelessUrl data attribute
          $('#date-and-nights-search-form').data('dateless-url', results.datelessUrl)
          // update the filterLessUrl
          $('#clear-all-filters-link').attr('href', results.filterLessUrl)

          if (results.flexibleDates && results.flexibleDates.length > 0) {
            for (var i in results.flexibleDates) {
              const flexDate = results.flexibleDates[i]
              const $flexDateAEl = $('#' + flexDate.htmlElementId)

              if (flexDate.current) {
                $flexDateAEl.addClass('currentday')
              } else {
                $flexDateAEl.removeClass('currentday')
              }
              if (flexDate.hasLink) {
                $flexDateAEl.removeClass('not-active')
              } else {
                $flexDateAEl.addClass('not-active')
              }
              $flexDateAEl.attr('href', flexDate.link)
              $flexDateAEl.find('.day').html(flexDate.day)
              $flexDateAEl.find('.date').html(flexDate.date)
              $flexDateAEl.find('.month').html(flexDate.month)
              $flexDateAEl.find('.number').html(flexDate.count)
            }
            resetSlick()
            $('#scrollToTop').animatescroll()
          }

          if (results.filters) {
            for (var i in results.filters) {
              const section = results.filters[i]
              for (const j in section.options) {
                const sectionOption = section.options[j]
                const checkBoxId = section.section + sectionOption.key
                $('#' + checkBoxId).prop('checked', false)
                $('label[for=\'' + checkBoxId + '\'] span.number').html(sectionOption.count)
                if (sectionOption.count > 0) {
                  $('#' + checkBoxId).attr('disabled', false)
                }
                if (sectionOption.hasOwnProperty('applied')) {
                  $('#' + checkBoxId).prop('checked', true)
                  $('#' + checkBoxId).attr('disabled', false)
                }
                $('#' + checkBoxId).data('toggle-url', sectionOption.optionToggleLink)
              }
              const $sectionHeading = $('#filters_section_' + section.section)
              if (section.appliedInSection) {
                $sectionHeading.addClass('items-selected')
              } else {
                $sectionHeading.removeClass('items-selected')
              }
              if (section.hasOwnProperty('optionsGroupings')) {
                for (const k in section.optionsGroupings) {
                  const sectionOptionsGroupings = section.optionsGroupings[k]
                  const sectionOptionsCheckboxId = section.section + '_optionsGrouping_' + k
                  let indeterminate = false
                  let checked = false
                  let nextState = 'checked'
                  if (sectionOptionsGroupings.hasOwnProperty('selectedStatus')) {
                    if (sectionOptionsGroupings.selectedStatus === 'partial') {
                      indeterminate = true
                    } else {
                      checked = true
                      nextState = 'none'
                    }
                  }
                  $('#' + sectionOptionsCheckboxId).prop('checked', checked)
                  $('#' + sectionOptionsCheckboxId).prop('indeterminate', indeterminate)
                  $('#' + sectionOptionsCheckboxId).data('toggle-url', sectionOptionsGroupings.optionToggleLink)
                  $('#' + sectionOptionsCheckboxId).data('next-state-will-be', nextState)
                  $('#' + sectionOptionsCheckboxId).attr('disabled', false)
                }
              }
            }
          } else {
            $('#filter-results').find('.checkbox .number').html(0)
          }

          if (results.hasFlights) {
            $('#selectedFlightSearchResultBox_Area').html(results.selectedFlightSearchResultBox)
            $('#selectedFlightSearchResultBox_Area').fadeIn()
            $('#alternativeFlightSearchResults_area').html(results.selectedFlightSearchAlternatives)

            // Reinitialize our flight form search results
            UTIL.fire('flights_search_form_results')
          }
          if (results.hasOwnProperty('noFlightResults')) {
            displayNoFlightResultsWarning()
          }

          $('.clear-button, .search-villas-button').attr('disabled', false)
          $('.search-villas-and-flights-button').html('Search').attr('disabled', false)
        } // end updateVillas function

        // Keep track of the current ajax request for filtering the villas
        let filterVillaRequestAjax = null

        const filterVillas = function (villasSearchUrl) {
          $('#filter-results span.number').html('<i class="fa fa-refresh fa-spin fa-fw"></i>')
          $('#selectedFlightSearchResultBox_Area').fadeOut()
          $('#alternativeFlightSearchResults_area').html('<div class="text-center" style="margin-top:30px;margin-bottom:30px;color:#ccc"><i class="fa fa-refresh fa-spin fa-fw fa-4x"></i></div>')
          $('.date-select-container .inner .number').html('<i class="fa fa-refresh fa-spin fa-fw"></i>')
          $('.filter-toggle').attr('disabled', true)
          $('.filter-toggle-options-group').attr('disabled', true)

          // Don't show loading icon if already exists
          if (!$('#with_flights_label').find('.fa').length) {
            $('#with_flights_label').html('<i class="fa fa-refresh fa-spin fa-fw"></i>' + $('#with_flights_label').html())
          }
          $('#with_flights').attr('disabled', true)
          $('#with_flights').closest('.form-group').css('opacity', 0.65)

          $('.pagination-container').fadeTo(null, 0)
          $('#no-results-text-area').fadeOut()
          $('#pageMainH1').fadeOut()
          $('.clear-button, .search-villas-button').html('<i class="fa fa-refresh fa-spin fa-fw"></i>').attr('disabled', true)
          $('.search-villas-and-flights-button').html('<i class="fa fa-refresh fa-spin fa-fw"></i>').attr('disabled', true)
          $('.search-results').fadeOut(150, function () {
            $('.search-results').html('<div class="text-center" style="margin-top:100px;color:#ccc"><i class="fa fa-refresh fa-spin fa-fw fa-4x"></i></div>')
            $('.search-results').fadeIn(0, function () {
              let fetchFilterHTML = false
              const $filterResults = $('#filter-results')

              // Check if we have filter options, if not we need to also fetch the filter options - show loading spinner
              if (!$filterResults.find('.row').length) {
                $filterResults.html('<div class="row"><div class="col-xs-12"><div class="text-center" style="color:#ccc"><i class="fa fa-refresh fa-spin fa-fw fa-2x"></i></div></div></div>')
                fetchFilterHTML = true
              }

              // If there's an existing ajax request, abort the ajax request.
              // We do this to stop multiple ajax requests being processed - as processing multiple ajax requests causes the page to jump around.
              if (filterVillaRequestAjax) {
                filterVillaRequestAjax.abort()
              }

              filterVillaRequestAjax = $.ajax({
                type: 'GET',
                url: villasSearchUrl,
                cache: false,
                data: {
                  need_filter_html: +fetchFilterHTML
                },
                success: updateVillas,
                error: function (data, textStatus, errorThrown) {
                  // Ignore abort error as that means we've aborted the request
                  if (data.statusText === 'abort') {
                    return
                  }

                  if (data.status === 303) {
                    window.location.href = data.responseJSON.redirect
                    return
                  }

                  // console.log('updateVillasError');
                  // console.log(textStatus)
                  // console.log(errorThrown)
                  alert('Sorry an error occured retrieving the results - please refresh your page')
                },
                complete: function () {
                  // Reset the ajax request
                  filterVillaRequestAjax = null
                }
              })
            })
          })
        } // end filterVillas function

        const updateSearchAndPushToHistory = function (newSearchCriteriaUrl) {
          let historyUrl = window.location.pathname
          if (location.search.length) {
            historyUrl += location.search
          }
          if (newSearchCriteriaUrl != historyUrl) {
            // there's a change in the url - lets load with new criteria

            // Check if we have outbound options set, we need to add them back into the url
            if (UTIL.getUrlParameter('with_flights')) {
              const flightSelectedOutBoundOption = UTIL.getUrlParameter('flightSelectedOutBoundOption')

              if (flightSelectedOutBoundOption) {
                // Check to see if flightSelectedOutBoundOption exists in newSearchCriteriaUrl string, if not add it if so replace
                if (newSearchCriteriaUrl.indexOf('flightSelectedOutBoundOption') === -1) {
                  newSearchCriteriaUrl += '&flightSelectedOutBoundOption=' + flightSelectedOutBoundOption
                } else {
                  newSearchCriteriaUrl = newSearchCriteriaUrl.replace(/flightSelectedOutBoundOption=[^&]*/, 'flightSelectedOutBoundOption=' + flightSelectedOutBoundOption)
                }
              }

              const flightSelectedInBoundOption = UTIL.getUrlParameter('flightSelectedInBoundOption')
              if (flightSelectedInBoundOption) {
                // Check to see if flightSelectedInBoundOption exists in newSearchCriteriaUrl string, if not add it if so replace
                if (newSearchCriteriaUrl.indexOf('flightSelectedInBoundOption') === -1) {
                  newSearchCriteriaUrl += '&flightSelectedInBoundOption=' + flightSelectedInBoundOption
                } else {
                  newSearchCriteriaUrl = newSearchCriteriaUrl.replace(/flightSelectedInBoundOption=[^&]*/, 'flightSelectedInBoundOption=' + flightSelectedInBoundOption)
                }
              }
            }

            history.pushState(newSearchCriteriaUrl, null, newSearchCriteriaUrl)
            filterVillas(newSearchCriteriaUrl)
          }
        } // end updateSearchAndPushToHistory function

        $('body').on('click', '.flexdate, ul.pagination li a, #clear-all-filters-link', function (e) {
          const linkhref = $(this).attr('href')
          updateSearchAndPushToHistory(linkhref)
          e.preventDefault()
        })

        const createReadMoreLandingPageCopy = function () {
          const $landingPageCopy = $('#landingPageCopy')
          const landingPageCopyHtmlHeadings = $landingPageCopy.find('h2, h3')
          if (landingPageCopyHtmlHeadings.length > 0) {
            $('<p>SPLITHERE</p>').insertBefore(landingPageCopyHtmlHeadings[0])
            const beforeAndAfterText = $landingPageCopy.html().split('<p>SPLITHERE</p>')
            $landingPageCopy.html(beforeAndAfterText[0])
            $landingPageCopy.append('<a href="#" class="read-more-landing-page-copy-button">Read More</a>')
            $landingPageCopy.append('<div class="landing-page-read-more-content">' + beforeAndAfterText[1] + '</div>')
            $('.landing-page-read-more-content').addClass('hidden')
          }
        }
        createReadMoreLandingPageCopy()

        $('body').on('click', '.read-more-landing-page-copy-button', function (e) {
          e.preventDefault()
          $('.read-more-landing-page-copy-button').addClass('hidden')
          $('.landing-page-read-more-content').removeClass('hidden')
        })

        const emptySearchResultsReadyForFlights = function () {
          flightSearchButtonNeedsPressing = true
          $('.date-select-container').fadeOut()
          $('#pageMainH1Area').fadeOut()
          $('#landingPageCopy').fadeOut()
          $('.pagination-container').fadeOut()
          $('#filter-results span.number').html('')
          $('#selectedFlightSearchResultBox_Area').html('')
          $('#alternativeFlightSearchResults_area').html('')
          $('.filter-toggle').attr('disabled', true)
          $('.filter-toggle-options-group').attr('disabled', true)
          $('#no-results-text-area').html('')
          $('.search-results').html('')
        }

        $('body').on('change', '#arrival, #nights, .filter-toggle, .filter-toggle-options-group, #with_flights', function () {
          if (flightSearchButtonNeedsPressing && $('#with_flights').val() == 1) {
            return
          }
          const $elementThatTriggeredChange = $(this)
          const elementIdOfItemChanged = $(this).attr('id')
          let searchCriteriaUrl

          if ($elementThatTriggeredChange.hasClass('filter-toggle') || $elementThatTriggeredChange.hasClass('filter-toggle-options-group')) {
            searchCriteriaUrl = $elementThatTriggeredChange.data('toggle-url')
            if ($elementThatTriggeredChange.hasClass('filter-toggle-options-group')) {
              $elementThatTriggeredChange.prop('indeterminate', false) // this will never be the next state if one of these checkboxes is toggled
              if ($elementThatTriggeredChange.data('next-state-will-be') === 'checked') {
                $elementThatTriggeredChange.prop('checked', true)
              } else {
                $elementThatTriggeredChange.prop('checked', false)
              }
            }
            // check if its bedroom or en-suite bathrooms and also apply greater than this number
            const filterSection = $elementThatTriggeredChange.data('filter-section')
            switch (filterSection) {
              case 'ensuite':
              case 'bedrooms':
                var newCheckedState = $elementThatTriggeredChange.prop('checked')
                if (newCheckedState) {
                  let queryStringToAppendOntoUrl = ''
                  const hasQueryString = searchCriteriaUrl.indexOf('?') > -1
                  if (hasQueryString) {
                    const urlPathForQueryString = searchCriteriaUrl.split('?')
                    queryStringToAppendOntoUrl = '?' + urlPathForQueryString[1]
                    searchCriteriaUrl = urlPathForQueryString[0]
                  }
                  // we're turning the option on - so we can apply the values greater than this
                  const urlPathParts = searchCriteriaUrl.split('/')
                  let urlPartToFind = filterSection // bedrooms are that in the url
                  if (filterSection == 'ensuite') {
                    urlPartToFind = 'en-suite-bathrooms'
                  }
                  for (const i in urlPathParts) {
                    const pathPart = urlPathParts[i]
                    if (pathPart.indexOf(urlPartToFind) > -1) {
                      const valuesAndFormPartName = pathPart.split('-' + urlPartToFind)
                      const existingValues = valuesAndFormPartName[0]
                      const justValues = existingValues.split('-or-')
                      const newValues = []
                      for (const k in justValues) {
                        // make the values integers
                        newValues.push(parseInt(justValues[k], 10))
                      }
                      const $parentFormGroup = $elementThatTriggeredChange.closest('.form-group')
                      const allPossibleValues = $parentFormGroup.data('possible-values').split(',')
                      const valueThatTriggeredTheChange = parseInt($elementThatTriggeredChange.val(), 10)
                      for (const j in allPossibleValues) {
                        const possibleValue = parseInt(allPossibleValues[j], 10)
                        if (parseInt(possibleValue, 10) > valueThatTriggeredTheChange) {
                          // make sure its not already in the array
                          if (existingValues.indexOf(possibleValue) < 0) {
                            newValues.push(possibleValue)
                          }
                          if (filterSection == 'bedrooms') { // we only want this restricted to the next largest one on the bedrooms, ensuites can have everything greater selected.
                            break // this stops it adding additional larger items - it'll stop with the 1st item greater being added (unless its already selected), remove this break to include all larger items being selected.
                          }
                        }
                      }
                      newValues.sort(function (a, b) {
                        return a - b
                      })
                      const newUrlPathPart = newValues.join('-or-') + '-' + urlPartToFind
                      urlPathParts[i] = newUrlPathPart
                      break // stop it looking at other path parts
                    }
                  }
                  const newPath = urlPathParts.join('/')
                  searchCriteriaUrl = newPath + queryStringToAppendOntoUrl
                }

                break
            }
          } else {
            // its the arrival datepicker or nights selector
            if (elementIdOfItemChanged == 'arrival') {
              // check if its the onchange event of it being reset after a flexible with your dates has been changed
              if ($('#arrival').data('dontlistenonset')) {
                $('#arrival').removeData('dontlistenonset')
                return
              }
            }
            let datelessUrl = $('#date-and-nights-search-form').data('dateless-url') || ''
            if (elementIdOfItemChanged == 'with_flights') {
              if ($elementThatTriggeredChange.val() == 1) {
                emptySearchResultsReadyForFlights()
                return
              } else {
                // if we turn flights off we can make the dateless url exclude flights by removing the ? onwards
                const datelessUrlParts = datelessUrl.split('?')
                datelessUrl = datelessUrlParts[0]
              }
            }
            $('.search-form').data('search-performed', true)
            const searchFormParams = {}
            searchFormParams.arrival = $('#arrival').pickadate('picker').get('select', 'yyyy-mm-dd')
            searchFormParams.nights = $('#nights').val()
            searchFormParams.with_flights = $('#with_flights').val()
            searchFormParams.force_change = new Date().getTime()
            const searchParams = $.param(searchFormParams)
            if (!datelessUrl.includes('?')) {
              datelessUrl += '?'
            } else {
              datelessUrl += '&'
            }
            searchCriteriaUrl = datelessUrl + searchParams
          }
          updateSearchAndPushToHistory(searchCriteriaUrl)
        })

        $('body').on('change', '#flight_from, #flight_to, #cabin_class, #direct_only, #adults, #children, #infants, .childAgeSelects', function () {
          emptySearchResultsReadyForFlights()
        })
      }
    },
    search_results_carousel: {
      // add all the slick carousels to the villa search results
      init: function () {
        setupSearchResultsCarousel()
      }
    },
    two_column_carousel: {
      init: function () {
        /**
        * -----------------------
        * Functions for this page
        * -----------------------
        */

        /**
        * Utility functions for toggling play and pause of carousel
        * @type {{play: play, pause: pause}}
        */
        const carousel = {
          play: function () {
            $('#villaInfoCarousel').addClass('autoplay-enabled').slick('slickPlay')
            $('#villaInfoCarousel .play-pause').css('color', 'rgba(255,255,255,1)')
            $('#villaInfoCarousel .play-pause').children('.fa').addClass('fa-pause').removeClass('fa-play')
            $('#villaInfoCarousel .play-pause').children('.text').text('Pause')
          },

          pause: function () {
            $('#villaInfoCarousel .play-pause').css('color', 'rgba(255,255,255,0.6)')
            $('#villaInfoCarousel').removeClass('autoplay-enabled').slick('slickPause')
            $('#villaInfoCarousel .play-pause').children('.fa').addClass('fa-play').removeClass('fa-pause')
            $('#villaInfoCarousel .play-pause').children('.text').text('Play')
          }
        }

        /**
        * Toggle pay and pause
        */
        function togglePlayPause() {
          if (!$('#villaInfoCarousel').hasClass('autoplay-enabled')) {
            carousel.play()
          } else {
            carousel.pause()
          }
        }

        /**
        * Carousels
        */

        $('.play-pause').on('click', function (e) {
          e.preventDefault()
          togglePlayPause()
        })

        if (($('#villaInfoCarouselControl > .img-outer').length) < 2) {
          $('#villaInfoCarousel .play-pause').hide()
        }

        if (($('#villaInfoCarouselControl > .img-outer').length) > 1) {
          let asNavFor = '#villaInfoCarouselControl'

          if ($('#villaInfoCarouselControl > .img-outer').length <= 3) {
            asNavFor = ''
          }

          // Large carousel
          $('#villaInfoCarousel').slick({
            arrows: true,
            dots: false,
            slide: '.img-outer',
            rows: 0,
            asNavFor,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '210px',
            pauseOnFocus: false,
            pauseOnHover: false,
            responsive: [
              {
                // md
                breakpoint: 1199,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '110px'
                }
              },
              {
                // sm
                breakpoint: 991,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false,
                  centerPadding: '0px'
                }

              },
              {
                // xs
                breakpoint: 767,
                settings: {
                  arrows: false,
                  slidesToScroll: 1,
                  slidesToShow: 1,
                  centerMode: false,
                  centerPadding: '0px'
                }
              }
            ]
          })

          if ($('#villaInfoCarouselControl > .img-outer').length > 3) {
            const smallSlidesToShow = {
              xs: 3,
              md: 7,
              lg: 9
            }

            if (($('#villaInfoCarouselControl > .img-outer').length) < smallSlidesToShow.xs) {
              smallSlidesToShow.xs = $('#villaInfoCarouselControl > .img-outer').length
            }

            if (($('#villaInfoCarouselControl > .img-outer').length - 1) < smallSlidesToShow.md) {
              smallSlidesToShow.md = $('#villaInfoCarouselControl > .img-outer').length - 1
            }

            if (($('#villaInfoCarouselControl > .img-outer').length - 1) < smallSlidesToShow.lg) {
              smallSlidesToShow.lg = $('#villaInfoCarouselControl > .img-outer').length - 1
            }

            $('#villaInfoCarouselControl').slick({
              arrows: false,
              dots: false,
              slidesToShow: smallSlidesToShow.lg,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '60px',
              focusOnSelect: true,
              infinite: true,
              slide: '.img-outer',
              rows: 0,
              asNavFor: '#villaInfoCarousel',
              pauseOnFocus: 'false',
              pauseOnHover: 'false',
              responsive: [
                {
                  // md
                  breakpoint: 1199,
                  settings: {
                    slidesToShow: smallSlidesToShow.md,
                    slidesToScroll: 1
                  }
                },
                {
                  // xs
                  breakpoint: 767,
                  settings: {
                    slidesToShow: smallSlidesToShow.xs,
                    centerPadding: '10px',
                    slidesToScroll: smallSlidesToShow.xs
                  }
                }
              ]
            })
          }
        }
      }
    },

    villa_info: {
      init: function () {
        /**
        * ------------------------
        * Stuff to do on page load
        * ------------------------
        */

        $('.top-panels-same-height').matchHeight()
        $('.highlightpanel').matchHeight()

        /**
        * Pagination controls
        */

        if ($('#villaPagination').length) {
          const totalPaginationNumber = $('#totalPagination').attr('data-number')
          const currentPaginationNumber = $('#currentPagination').attr('data-number')

          if (typeof CountUp === 'function') {
            const totalPagination = new CountUp('totalPagination', 1, totalPaginationNumber)
            const currentPagination = new CountUp('currentPagination', 1, currentPaginationNumber)

            if ((!totalPagination.error) && (!currentPagination.error)) {
              totalPagination.start()
              currentPagination.start()
            } else {
              $('#totalPagination').css('display', 'none').text(totalPaginationNumber).fadeIn()
              $('#currentPagination').css('display', 'none').text(currentPaginationNumber).fadeIn()
            }
          } else {
            $('#totalPagination').css('display', 'none').text(totalPaginationNumber).fadeIn()
            $('#currentPagination').css('display', 'none').text(currentPaginationNumber).fadeIn()
          }
        }

        /**
        * Reviews & comments
        */

        const removeReadMoreButton = function () {
          $('.read-more-reviews').css('pointer-events', 'none')
          $('.read-more-reviews').fadeTo(null, 0)
        }

        $('.read-more-reviews').on('click', function (e) {
          e.preventDefault()
          removeReadMoreButton()
          $('.testimonial-hidden').fadeTo(1, 0, function () {
            $('.testimonial-hidden').addClass('testimonial-shown fading')
            $('.testimonial-shown.fading').each(function (i, obj) {
              $(this).removeClass('testimonial-hidden')
              $(this).fadeTo(null, 1)
            })
          })
        })

        /**
        * Restructure page - move reviews and comments below villa details on mobile
        */
        function pageRestructure() {
          const reviewsAndComments = $('.reviews-comments-container')
          if ($(window).width() < 992) {
            $(reviewsAndComments).appendTo('#review-comments-outer-container-bottom')
          } else {
            $(reviewsAndComments).appendTo('#review-comments-outer-container-side')
          }
        }

        /**
        * ----------------------------
        * Stuff to do on Window resize
        * ----------------------------
        */
        const windowResize = debounce(function () {
          pageRestructure()
        }, 250)

        window.addEventListener('resize', windowResize)

        /**
        * Moving content on xs screens
        */
        pageRestructure()

        /**
        * Handle the availability calendar
        */
        const $calendarAvailable = $('.select-date')
        const $villaChooseNightsModal = $('#villa-choose-nights-modal')
        const $selectNightsButton = $villaChooseNightsModal.find('.choose-nights')

        let selectedNight = 0
        let arrivalDate = ''
        let villa = ''

        $selectNightsButton.on('click', function (e) {
          // Get width of button
          const buttonWidth = $(this).outerWidth()

          $(this).html('<i class="fa fa-spinner fa-spin"></i>')

          // Set the width
          $(this).css('width', buttonWidth)

          // Direct user to the Villa Extras page
          window.location.href = `/checkout/all/villa-extras?villa=${villa}&arrival=${arrivalDate}&nights=${selectedNight}`
        })

        $calendarAvailable.on('click', (e) => {
          e.preventDefault()

          const $this = $(e.currentTarget)

          selectedNight = 0
          villa = $this.data('villa')
          arrivalDate = $this.data('arrival-date')
          const arrivalDateFormatted = $this.data('arrival-date-formatted')

          $villaChooseNightsModal.find('.modal-title').html(`Check in ${arrivalDateFormatted}`)

          const $bodyContent = $villaChooseNightsModal.find('.modal-body_content')
          const $bodyLoader = $villaChooseNightsModal.find('.modal-body_loader')
          $selectNightsButton.attr('disabled', true)

          // Show loading
          $bodyContent.addClass('hidden')
          $bodyLoader.removeClass('hidden')

          // Show the modal
          $villaChooseNightsModal.modal('show')

          // Do an ajax call to get the html content using href
          $.ajax({
            url: $(e.currentTarget).attr('href'),
            type: 'GET',
            dataType: 'json',
            success: function (data) {
              $bodyContent.html(data.content)

              $bodyContent.find('select').on('change', function (event, params) {
                if ($(this).val()) {
                  selectedNight = $(this).val()
                  $selectNightsButton.attr('disabled', false)
                } else {
                  $selectNightsButton.attr('disabled', true)
                }
              })

              $bodyContent.find('select').chosen({
                width: '100%'
              })

              $bodyContent.removeClass('hidden')
              $bodyLoader.addClass('hidden')
            },
            error: function (data) {
              let title = 'Error'
              let text = 'Error loading the night options, please try again later.'
              if (data.status === 403) {
                title = ''
                text = `<span>Please contact us on <b>01892 836822</b> about your enquiry on this villa <b>${villa}</b>. Thank you.</span>`
              } else {
                if (isProduction()) {
                  Bugsnag.notify({
                    name: 'Error loading the Villa Select Date Modal',
                    message: 'Failed to get the content'
                  })
                }
              }

              $villaChooseNightsModal.modal('hide')
              createAlert(title, text)
            }
          })
        })

        analyticsEvent('remarketing')
      }
    },

    grid_view: {
      init: function () {
        $('article').matchHeight()
      }
    },

    about_florida_shopping: {
      init: function () {
        $('article').matchHeight()
      }
    },

    about_florida_dining_out: {
      init: function () {
        $('article').matchHeight()
      }
    },

    about_florida_golf: {
      init: function () {
        $('article').matchHeight()
      }
    },

    about_florida_theme_parks: {
      init: function () {
        $('article').matchHeight()
      }
    },

    about_florida_sports: {
      init: function () {
        $('article').matchHeight()
      }
    },

    about_florida_weather: {
      init: function () {
        /**
        * ------------------------
        * Stuff to do on page load
        * ------------------------
        */

        /**
        * Weather carousel (7 day forecast)
        */
        $('.forecast-selector').slick({
          arrows: false,
          slidesToShow: 7,
          infinite: false,
          slidesToScroll: 7,
          slide: '.outer',
          rows: 0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: false,
                slide: '.outer',
                dots: false
              }
            },

            {
              breakpoint: 560,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                slide: '.outer',
                dots: false
              }
            }
          ]
        })

        /**
        * Weather carousel (36 hour forecast)
        */
        $('.hourly-forecast-selector').slick({
          arrows: false,
          infinite: false,
          slidesToShow: 7,
          slidesToScroll: 7,
          slide: '.outer',
          rows: 0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: false,
                infinite: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                slide: '.outer',
                dots: false
              }
            },

            {
              breakpoint: 560,
              settings: {
                arrows: false,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                slide: '.outer',
                dots: false
              }
            }
          ]
        })
      }
    },

    about_us_testimonials_leave: {
      init: function () {
        /**
        * ------------------------
        * Functions we need to use
        * ------------------------
        */

        /**
        * Text area height
        */
        function textAreaHeight() {
          const lsContainerHeight = $('.ls-container').innerHeight()
          const newHeight = lsContainerHeight - 22
          $('#testimonial').innerHeight(newHeight)
        }

        /**
        * ----------------------------
        * Stuff to do on Window resize
        * ----------------------------
        */
        const windowResize = debounce(function () {
          textAreaHeight()
        }, 250)

        window.addEventListener('resize', windowResize)

        /**
        * ------------------------
        * Stuff to do on page load
        * ------------------------
        */
        const $testimonialArea = $('#testimonial')

        /**
        * Make text area the same height as rest of form and check testimonial counter length and set to red if too long
        */
        setTimeout(function () { // needs the delay to work properly
          textAreaHeight()
          setTestimonialCounterAndTextColour()
        }, 250)

        const setTestimonialCounterAndTextColour = function () {
          const charCount = $testimonialArea.val() ? $testimonialArea.val().length : 0
          const maxChars = $testimonialArea.data('maxlength')
          const remainingChars = maxChars - charCount
          const textAreaTextColor = (remainingChars >= 0) ? 'black' : 'red'
          $testimonialArea.parent().siblings('.character-count').children('.char-count').html(remainingChars)
          $testimonialArea.css('color', textAreaTextColor)
        }

        $('#testimonial').keyup(setTestimonialCounterAndTextColour)
      }
    },

    about_us_newsletters: {
      init: function () {
        $('.section-description').matchHeight()
      }
    },

    car_hire: {
      init: function () {
        /** *
        * --------------------------
        * Functions we will be using
        * --------------------------
        */

        $('.car-result .inner-panel').matchHeight()

        $('body').on('change', '.clearDestinationSearchType', function (e) {
          $radioButton = $(this)
          const elementId = $radioButton.data('elementId')
          resetAutoCompleteForm(elementId)
        })

        // Form
        $('#sameLocationToggle').change(function () {
          if (this.checked) {
            resetAutoCompleteForm('carHire_return')
            $('#return_Container').fadeOut()
          } else {
            $('#return_Container').fadeIn()
          }
        })

        $('.rental-terms-modal').on('show.bs.modal', function (e) {
          $('.rental-terms-modal .modal-body').html('<div class="row"><div class="col-xs-12 text-center" style="line-height:200px;"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div></div>')
          const link = $(e.relatedTarget)
          const _url = link.attr('href')
          $.ajax({
            type: 'GET',
            url: _url,
            cache: false,
            success: function (response) {
              const oResponse = $.parseJSON(response)
              $('.rental-terms-modal .modal-body').html(oResponse.body)
            }
          })
        })

        // car hire form validation
        const destroyCarHireFormTooltipErrors = function () {
          $('.car-hire-form *').filter(':input, .tooltip-area').each(function () {
            $(this).tooltip('destroy')
          })
        }

        // destroy the tooltips on checks being changed or fields being focussed
        $('#carHire_pickup_search, #carHire_return_search, #driver_age, #arrival, #departure, #arrivaltime, #departuretime').focus(function () {
          destroyCarHireFormTooltipErrors()
        })

        $('body').on('change', '.clearDestinationSearchType, #sameLocationToggle, #driver_age', function () {
          destroyCarHireFormTooltipErrors()
        })

        $('#source_country').on('chosen:showing_dropdown chosen:hiding_dropdown', function () {
          destroyCarHireFormTooltipErrors()
        })

        $('.car-hire-form').on('submit', function (e) {
          // set by default no errors - form will submit
          let formError = false

          // check we have a pickup location
          if (!$('#carHire_pickup').val()) {
            formError = true
            var toolTipAreaId = '#carHire_pickup_tooltipArea'
            $(toolTipAreaId).tooltip({
              placement: 'bottom',
              title: 'Please enter a pick up location',
              trigger: 'manual'
            })
            $(toolTipAreaId).tooltip('show')
          }

          // check if return location if sameLocationToggle checkbox is not checked
          if (!$('#sameLocationToggle').is(':checked') && (!$('#carHire_return').val())) {
            formError = true
            var toolTipAreaId = '#carHire_return_tooltipArea'
            $(toolTipAreaId).tooltip({
              placement: 'bottom',
              title: 'Please enter a drop off location',
              trigger: 'manual'
            })
            $(toolTipAreaId).tooltip('show')
          }

          // check if age entered of the driver is correct
          const driverAgeValue = $('#driver_age').val()
          const driverAgeErrorTooltip = checkCarHireDriverAgeSetCorrectly(driverAgeValue)

          if (driverAgeErrorTooltip != '') {
            formError = true
            $('#driver_age').tooltip({
              placement: 'bottom',
              title: driverAgeErrorTooltip,
              trigger: 'manual'
            })
            $('#driver_age').tooltip('show')
          }

          // check source_country is set
          if (!$('#source_country').val()) {
            formError = true
            var toolTipAreaId = '#source_country_tooltipArea'
            $(toolTipAreaId).tooltip({
              placement: 'bottom',
              title: 'Please select the Lead driver\'s country of residence',
              trigger: 'manual'
            })
            $(toolTipAreaId).tooltip('show')
          }

          const dateAndTimeFields = []
          dateAndTimeFields.push({ name: 'date from', selector: '#arrival', pickertype: 'date' })
          dateAndTimeFields.push({ name: 'date to', selector: '#departure', pickertype: 'date' })
          dateAndTimeFields.push({ name: 'time from', selector: '#arrivaltime', pickertype: 'time' })
          dateAndTimeFields.push({ name: 'time to', selector: '#departuretime', pickertype: 'time' })
          for (const i in dateAndTimeFields) {
            const thisDateOrTimeField = dateAndTimeFields[i]
            const $inputElement = $(thisDateOrTimeField.selector)
            var dateOrTime
            switch (thisDateOrTimeField.pickertype) {
              case 'date':
                dateOrTime = $inputElement.pickadate('picker').get('value')
                break
              case 'time':
                dateOrTime = $inputElement.pickatime('picker').get('value')
                break
            }
            if (!dateOrTime) {
              formError = true
              $inputElement.tooltip({
                placement: 'bottom',
                title: ('Please enter a ' + thisDateOrTimeField.name),
                trigger: 'manual'
              })
              $inputElement.tooltip('show')
            }
          }

          if (formError) {
            e.preventDefault()
          } else {
            $('.continue-without-link-area').slideUp(400)
            $('#carHireSearchForm').slideUp(400, function () {
              $('.loader-outer').addClass('search-in-progress')

              if ($('#carHireResults').length) {
                $('#carHireResults').fadeOut(400, function () {
                  $('#loadingSpinner').slideDown(400)
                })
              } else {
                $('#loadingSpinner').slideDown(400)
              }
            })
          }
        })

        // Filter buttons on Car Hire results
        $('button.filter-button').on('click', function () {
          const filterGroup = $(this).attr('data-filter-group')
          // console.log(filterGroup);

          if (filterGroup !== 'all') {
            $('[data-filter-group="' + filterGroup + '"]').removeClass('active')
            $('[data-filter-group="' + 'all' + '"]').removeClass('active')
          } else {
            $('button.filter-button').removeClass('active')
          }

          $(this).addClass('active')

          const visibleResults = $(this).attr('data-total-results')
          $('#totalCars').text(visibleResults)
        })

        analyticsEvent('view_carhire')
      }
    },

    car_hire_confirm: {
      init: function () {
        $('.car-chosen-form select').on('change', function () {
          const $selectElement = $(this)
          let elementName = $selectElement.attr('name')
          if (elementName.indexOf('local') >= 0) {
            elementName = 'local'
          }
          const $totalArea = $('#total_area_' + elementName)
          const $totalPrice = $('#total_' + elementName)
          $totalArea.removeClass('hidden')
          $totalPrice.html('Updating')

          const values = $('.car-chosen-form').serialize()
          const _url = $(this).parents('form:first').attr('action')

          $.ajax({
            type: 'POST',
            url: _url,
            cache: false,
            data: values,
            success: function (response) {
              const oResponse = $.parseJSON(response)
              const theExtrasPurchased = {}
              if (oResponse.r.extras) {
                const extrasPurchased = oResponse.r.extras
                for (const i in extrasPurchased) {
                  const thisExtra = extrasPurchased[i]
                  theExtrasPurchased[thisExtra.code] = { cost: thisExtra.cost, qty: thisExtra.qty }
                }
              }

              let localExtrasPurchased = 0
              $('.car-chosen-form select').each(function () {
                const $element = $(this)
                const thisElementName = $element.attr('name')
                let qty = 0
                let cost = '&pound;0.00'
                if (theExtrasPurchased[thisElementName] !== undefined) {
                  qty = parseInt(theExtrasPurchased[thisElementName].qty, 10)
                  cost = theExtrasPurchased[thisElementName].cost
                }
                $(this).val(qty)
                const $totalArea = $('#total_area_' + thisElementName)
                const $totalPrice = $('#total_' + thisElementName)
                if (thisElementName.indexOf('local') >= 0) {
                  localExtrasPurchased += qty
                } else {
                  $totalPrice.html(cost)
                  if (qty > 0) {
                    $totalArea.removeClass('hidden')
                  } else {
                    $totalArea.addClass('hidden')
                  }
                }
              })

              const $localTotalArea = $('#total_area_local')
              const $localTotalPrice = $('#total_local')

              if (localExtrasPurchased > 0) {
                $localTotalArea.removeClass('hidden')
                $localTotalPrice.html('Paid Locally')
              } else {
                $localTotalArea.addClass('hidden')
                $localTotalPrice.html('')
              }
              if (oResponse.r.grandTotal) {
                grandTotal = oResponse.r.grandTotal
              }
              if (oResponse.r.grandTotalFlyDrive) {
                grandTotal = oResponse.r.grandTotalFlyDrive
              }
              $('#grand_total').html(grandTotal)
              if (oResponse.basketHTML) {
                $('#checkoutCartArea').html(oResponse.basketHTML)
              }
            },
            error: function (response) {
              // console.log(response.responseText);
            }
          })
        })

        // Important information
        $('#toggleImportantInfo').on('click', function (e) {
          e.preventDefault()
          $('#car-hire-terms-accordion').slideDown(400, function () {
            $('#toggleImportantInfo').fadeOut()
          })
        })

        analyticsEvent('update_checkout')
      }
    },

    checkout_villa_extras: {
      init: function () {
        analyticsEvent('begin_checkout')
        analyticsEvent('view_villa_extras')

        $('.villa-extra-select').on('change', function () {
          const $selectElement = $(this)
          const _extraId = $selectElement.data('extraid')
          const _url = $(this).parents('form:first').attr('action')
          const $formElement = $selectElement.parents('form:first')

          const values = $formElement.serialize()

          const $totalArea = $('#total_area_' + _extraId)
          const $totalPrice = $('#total_' + _extraId)

          $totalArea.removeClass('hidden')
          $totalPrice.html('Updating')

          $.ajax({
            type: 'POST',
            url: _url,
            cache: false,
            data: values,
            success: function (response) {
              const oResponse = $.parseJSON(response)
              if (oResponse.r) {
                if (oResponse.r.extrasPurchased) {
                  const extrasPurchased = oResponse.r.extrasPurchased
                  $('.villa-extra-select').each(function () {
                    const $element = $(this)
                    const extraId = $element.attr('data-extraId')
                    const $totalArea = $('#total_area_' + extraId)
                    const $totalPrice = $('#total_' + extraId)
                    if (extrasPurchased[extraId]) {
                      $totalArea.removeClass('hidden')
                      $totalPrice.html(extrasPurchased[extraId].total_displayed)
                    } else {
                      $totalArea.addClass('hidden')
                      $totalPrice.html('&pound;0.00')
                      $(this).val(0)
                    }
                  })
                }
              }
              if (oResponse.basketHTML) {
                $('#checkoutCartArea').html(oResponse.basketHTML)
              }

              analyticsEvent('update_checkout')
            },
            error: function (response) {
              // alert(response.responseText);
            }
          })
        })

        $('.finalising-flight-quote').on('click', function () {
          $(this).html('<i class="fa fa-refresh fa-spin fa-fw"></i>')
          $(this).attr('disabled', true)

          createModal('', `
            <div class="loading-flights">
              <div class="loading-flights_content">
                <div class="loading-flights_icon">
                  <img src="/dist/images/flights/aircraft.svg" alt="Aircraft"/>
                </div>
                <div class="loading-flights_text">
                  <h3>Finalising your flight quote</h3>
                  <p>Please wait while we are finalising your flight quote.</p>
                </div>
              </div>
            </div>
          `, {
            showHeader: false,
            showFooter: false,
            disableBackdrop: true
          })
        })

        $('.panel-body').matchHeight()
      }
    },

    checkout_attraction_tickets: {
      init: function () {
        $('.theme-park-tooltip').tooltipster({
          theme: ['tooltipster-shadow'],
          contentCloning: true
          // minWidth: 250
          // interactive: true,
          // trigger: 'click'
        })

        $.extend($.fn.pickadate.defaults, {
          format: 'dd/mm/yyyy',
          formatSubmit: 'yyyy-mm-dd',
          hiddenName: true,
          clear: '',
          today: '',
          selectYears: true,
          onClose: function () {
            this.$holder.blur()

            /* on close reset the selected value back to what is selected as we can navigate to a different month and close the picker - once reopened it would display the month we navigated to rather than the date that has been set - these following lines reset it on close if the month and year is different from the selected value */
            const selectMonthYear = this.get('select', 'yyyy-mm')
            const highlightMonthYear = this.get('highlight', 'yyyy-mm')
            if (selectMonthYear !== highlightMonthYear) {
              this.set({
                select: this.get('select')
              })
            }
          }
        })

        // Global Selected Date Modal which is used by all tickets
        const selectDateModal = new SelectDateModal($('#attraction-tickets-select-dates-modal'))
        const checkout = new Checkout()
        checkout.init()

        function SelectDateModal($modal) {
          this.availability = []
          this.selectedDate = null
          this.options = []
          this.ticket = null
          this.initialLoad = false
          this.totalPrice = 0
          this.updating = false
          this.selectedTimeSlotId = null
          this.$modal = $modal
          const $this = this

          /**
           * Update Total
           */
          $this.updateTotal = function () {
            $this.totalPrice = 0
            for (let i = 0; i < $this.options.length; i++) {
              $this.totalPrice += Number($this.options[i].totalPrice)
            }

            // Also update the price
            $modal.find('.total_price_value').html('£' + $this.totalPrice.numberFormat(2))
          }

          // Get the total quantity from all passengers
          $this.passengerQuantity = function () {
            let quantity = 0
            for (let i = 0; i < $this.options.length; i++) {
              quantity += Number($this.options[i].quantity)
            }

            // Also update the ticket quantity
            $this.ticket.passengerQuantity = quantity

            return quantity
          }

          // Update Basket State
          $this.updateBasketState = function () {
            const $basket = $modal.find('.add-to-basket')
            const $errorMessage = $modal.find('.error-message')
            const $timeSlot = $modal.find('.time-slot')
            const passengerQuantity = $this.passengerQuantity()

            // Set basket width to auto
            $basket.css('width', 'auto')

            // If there's a passenger quantity, then show the time slot - else hide it
            if (passengerQuantity > 0 && $this.selectedTimeSlotId != null) {
              $timeSlot.show()
            } else {
              $timeSlot.hide()
            }

            if (passengerQuantity <= 0 && $this.updating == true) {
              $basket.html('Remove from Basket')
              $this.enableBasket(true)
              return
            }

            if ($this.updating == true) {
              $basket.html('Update Basket')
            } else {
              $basket.html('Add to Basket')
            }

            if (passengerQuantity <= 0) {
              $this.enableBasket(false)
              $errorMessage.addClass('hidden')
              return
            } else {
              $this.enableBasket(true)
            }

            if (passengerQuantity && passengerQuantity < $this.ticket.minBookingQuantity) {
              $errorMessage.removeClass('hidden')
              $errorMessage.html('<p style="margin-bottom: 0px">Minimum amount of people required to book this ticket is <strong>' + $this.ticket.minBookingQuantity + '</strong>.</p>')
              $this.enableBasket(false)
            } else if (passengerQuantity && passengerQuantity > $this.ticket.maxBookingQuantity) {
              $errorMessage.removeClass('hidden')
              $errorMessage.html('<p style="margin-bottom: 0px">Maximum amount of people per ticket is <strong>' + $this.ticket.maxBookingQuantity + '</strong>.</p>' +
                '<p>Please phone us if you require more than <strong>' + $this.ticket.maxBookingQuantity + '</strong> people for this attraction.</p>')
              $this.enableBasket(false)
            } // else if (passengerQuantity > $this.availability.spotsLeft) {
            // $errorMessage.removeClass('hidden')
            // $errorMessage.html('<p style="margin-bottom: 0px">There are only <strong>' + $this.availability.spotsLeft + '</strong> spots left for this date.</p>')
            // $this.enableBasket(false)
            // }
            else {
              $errorMessage.addClass('hidden')
            }

            if ($this.availability.length === 0) {
              $errorMessage.removeClass('hidden')
              $errorMessage.html('<p style="margin-bottom: 0px">Unfortunately there is no availability for this date and number of tickets requested.</p>')
              $modal.find('.total').addClass('hidden')
              $this.enableBasket(false)
            } else {
              $modal.find('.total').removeClass('hidden')
            }

            // Check if qualify for free guide book
            const freeGuideBook = checkout.extras.bookExtra
            if (freeGuideBook) {
              if ($this.totalPrice >= Number(freeGuideBook.$extra.data('qualify-price'))) {
                freeGuideBook.selected = true
              } else {
                freeGuideBook.selected = false
              }
            }
          }

          // Enable/Disable Basket Button
          $this.enableBasket = function (enable) {
            $modal.find('.add-to-basket').attr('disabled', !enable)
          }

          // Show loading
          $this.showLoading = function (show) {
            if (show) {
              $modal.find('.loading').show()
              $modal.find('.select-date_content').hide()
              $modal.find('.no-availability').hide()
            } else {
              $modal.find('.loading').hide()
            }
          }

          /**
           * Get the passengers
           */
          $this.passengers = function () {
            const passengers = []
            for (let i = 0; i < $this.options.length; i++) {
              passengers.push({
                type: $this.options[i].type,
                quantity: $this.options[i].quantity
              })
            }

            return passengers
          }

          $this.updatePrices = function (data) {
            // Update the prices, as the price could change depending which date the user selects on
            for (let i = 0; i < data.passengers.length; i++) {
              // It's in the same order, so no need to do any additional checking
              const option = $this.options[i]
              const price = data.passengers[i]
              option.price = Number(price.price)
              option.hasDeal = price.hasDeal
              option.originalPrice = price.originalPrice ? Number(price.originalPrice) : null

              // Update the total for each option
              option.updateTotal()
            }

            $this.updateTotal()
          }

          /**
           * Update the Time Slot
           *
           * @param {Array} data Data of the response
           */
          $this.updateTimeSlots = function (data) {
            const $timeSlot = $modal.find('.time-slot')

            // Hide timeslot by default
            // The 'Update Basket State' handles whether to show this or not
            $timeSlot.hide()

            if (data.timeSlots && data.timeSlots.length) {
              const $timeSlotOptionsSelect = $modal.find('.time-slot_times_options')

              // Clear the options
              $timeSlotOptionsSelect.html('')

              // Add the options
              for (const timeSlot of data.timeSlots) {
                $timeSlotOptionsSelect.append(`<option value="${timeSlot.id}" ${timeSlot.selected ? (timeSlot.selected === true ? 'selected' : '') : ''}>${timeSlot.time}</option>`)

                if (timeSlot.selected) {
                  $this.selectedTimeSlotId = timeSlot.id
                }
              }

              // Add a listener to the select
              $timeSlotOptionsSelect.one('change', function () {
                $this.selectedTimeSlotId = $(this).val()
              })

              if (!$this.selectedTimeSlotId) {
                // Set the first option as selected
                $timeSlotOptionsSelect.find('option:first').attr('selected', 'selected')

                // Also set our selectedTimeSlotId
                $this.selectedTimeSlotId = $timeSlotOptionsSelect.val()
              }
            }
          }

          // Check the availability
          $this.checkAvailability = function (datePicker, $modal) {
            $this.selectedDate = datePicker.get('select', 'yyyy-mm-dd')
            $this.selectedTimeSlotId = null

            $this.showLoading(true)
            $this.enableBasket(false)

            $this.isAvailable(function (data) {
              // If there's no length, then there's no availability
              if (data.length === 0) {
                $modal.find('.no-availability').show()
                $modal.find('.select-date_content').hide()
              } else {
                // There's an availability, let's show the adult, children and infant options
                $modal.find('.no-availability').hide()
                $modal.find('.select-date_content').show()

                $this.updatePrices(data)
                $this.updateTimeSlots(data)

                $this.updateBasketState()
              }
            }, function () {
              $this.showLoading(false)
              $this.initialLoad = true
            })
          }

          // Dynamic content will be handled here
          $this.init = function (ticket, $caller) {
            $this.ticket = ticket
            // Also reset the variables here aswell
            $this.options = []
            $this.selectedTimeSlotId = null

            const callerTextBefore = $caller.html()

            if ($caller) {
              $caller.html('<i class="fa fa-spinner fa-spin"></i>')
            }

            let url = '/ajax/attraction-tickets/' + $this.ticket.ticketId + '/select-date' + '?ref=' + $this.ticket.ref

            // If the URL contains 'manage-my-booking' add it to the url so the session model can identify if it needs to return a 401 if the manage my
            // booking session has expired
            if (window.location.href.indexOf('manage-my-booking') > -1) {
              url += '&manage-my-booking=1'
            }

            $.ajax({
              type: 'GET',
              url,
              cache: false,
              dataType: 'json',
              success: function (data) {
                $modal.find('.modal-header .modal-title').html(data.title)
                $modal.find('.modal-body').html(data.body)

                // Updating existing basket or adding to basket
                $this.updating = data.update

                if (data.availability) {
                  $this.availability = data.availability
                } else {
                  $this.availability = []
                }

                // Set our options
                $modal.find('.passenger').each(function () {
                  const option = new Option($(this), $this)
                  $this.options.push(option)

                  option.init()
                })

                // Update the total and also update the basket state
                $this.updateTotal()
                $this.updateTimeSlots(data)
                $this.updateBasketState()

                const $datePicker = $modal.find('.datepickercont')
                const startDate = moment($datePicker.data('startdate'))
                const endDate = moment($datePicker.data('enddate'))
                const selectedDate = moment($datePicker.data('selecteddate'))
                const blockedDates = $datePicker.data('blocked-dates')

                $this.selectedDate = $datePicker.data('selecteddate')

                // PickADate requires the disable dates to be in Date Object,
                // So turn the dates into a Date Object
                const blockedDatesArray = []
                for (const blockedDate of blockedDates) {
                  blockedDatesArray.push(new Date(blockedDate))
                }

                let initialize = false

                const $selectDate = $('#select-date')
                $selectDate.pickadate({
                  container: '#from-date-container',
                  disable: blockedDatesArray,
                  onSet: function (callBackValue) {
                    if (callBackValue.hasOwnProperty('highlight')) {
                      return
                    }

                    // Prevent the first call, as the code below I set the selected date,
                    // which also in turn trigger onSet callback...
                    // TODO; Is there a cleaner way?
                    if (!initialize) {
                      initialize = true
                      return
                    }

                    $this.checkAvailability(this, $modal)
                  }
                })

                $selectDate.pickadate('picker').set({
                  min: startDate.toDate(),
                  max: endDate.toDate(),
                  select: selectedDate.toDate()
                })

                $modal.modal('show')
              },
              error: function (data) {
                $modal.modal('hide')

                // If 401 it means their session has expired.
                if (data.status === 401) {
                  createAlert('Session expired', 'Your session has expired. Please click <a href="/manage-my-booking/login?expired=1">here</a> to login again.', {
                    onHide: function () {
                      window.location = '/manage-my-booking/login?expired=1'
                    }
                  })
                } else {
                  createAlert('Error Occured', 'There was an error loading the ticket details. Please try again later.')
                }
              },
              complete: function () {
                if ($caller) {
                  $caller.html(callerTextBefore)
                }
              }
            })
          }

          // Check Availability with callback
          $this.isAvailable = (callBack, completeCallBack = null) => {
            let url = '/ajax/attraction-tickets/' + $this.ticket.ticketId + '/check-availability'

            // If the URL contains 'manage-my-booking' add it to the url so the session model can identify if it needs to return a 401 if the manage my
            // booking session has expired
            if (window.location.href.indexOf('manage-my-booking') > -1) {
              url += '?manage-my-booking=1'
            }

            $.ajax({
              type: 'POST',
              url,
              data: {
                fromDate: $this.selectedDate,
                quantity: $this.passengerQuantity()
              },
              cache: false,
              dataType: 'json',
              success: function (data) {
                $this.availability = data
                $this.ticket.selectedDate = $this.selectedDate

                callBack(data)
              },
              error: function (data) {
                $modal.modal('hide')

                // If 401 it means their session has expired.
                if (data.status === 401) {
                  createAlert('Session expired', 'Your session has expired. Please click <a href="/manage-my-booking/login?expired=1">here</a> to login again.', {
                    onHide: function () {
                      window.location = '/manage-my-booking/login?expired=1'
                    }
                  })
                } else {
                  createAlert('Error Occured', 'There was an error loading the ticket details. Please try again later.')
                }
              },
              complete: function () {
                if (completeCallBack !== null) {
                  completeCallBack()
                }
              }
            })
          }

          // Add to basket
          $modal.find('.add-to-basket').on('click', function (e) {
            e.preventDefault()

            // Get width of the button
            const width = $(this).width()

            // Add loading icon
            $(this).html('<i class="fa fa-spinner fa-spin"></i>')

            // Adjust width
            $(this).width(width)

            const addToBasket = () => {
              const bookingReference = $('.ticket-container').data('ref')
              const paramsProduct = $('.ticket-container').data('product-type')
              let url = '/checkout/ajaxAndPostMethods'

              if (bookingReference) {
                url += '/' + bookingReference
              }

              $.ajax({
                type: 'POST',
                url,
                dataType: 'json',
                data: {
                  product: 'tickets',
                  params_product: paramsProduct,
                  availabilityId: $this.availability.id,
                  ticketId: $this.availability.ticketId,
                  passengers: $this.passengers(),
                  timeSlotId: $this.selectedTimeSlotId
                },
                success: function (data) {
                  // Update Cart
                  $('#checkoutCartArea').html(data.basketHTML)

                  // Update Total
                  $this.ticket.updateTotal($this.totalPrice)

                  for (const category of checkout.categories) {
                    for (const ticket of category.tickets) {
                      if ($this.ticket != ticket && $this.ticket.ticketId == ticket.ticketId) {
                        ticket.setPassengerQuantity($this.ticket.passengerQuantity)
                        ticket.updateTotal($this.ticket.totalPrice)
                      }
                    }
                  }

                  checkout.render()

                  analyticsEvent('update_checkout')
                },
                error: function () {
                  $modal.modal('hide')
                  createAlert('Error Occured', 'There was an error adding the ticket to the basket.')
                },
                complete: function () {
                  $modal.modal('hide')
                }
              })
            }

            // If not removing from basket, check the availability again
            if ($this.passengerQuantity() > 0) {
              $this.isAvailable(function (data) {
                if (data.length === 0) {
                  $modal.find('.no-availability').show()
                  $modal.find('.select-date_content').hide()

                  $this.updateBasketState()
                  $this.enableBasket(false)
                } else {
                  addToBasket()
                }
              })
            } else {
              addToBasket()
            }
          })
        }

        // Option (passengers)
        function Option($option, selectDateModal) {
          this.price = Number($option.data('price'))
          this.hasDeal = $option.data('has-deal')
          this.originalPrice = $option.data('original-price')
          this.totalPrice = 0
          this.type = $option.data('type')
          this.quantity = $option.data('quantity')
          const $this = this

          $this.updateTotal = function () {
            $this.totalPrice = Number($this.price * $this.quantity)

            // Update label incase price changes
            $option.find('.passenger_price').html('£' + $this.price)

            if ($this.hasDeal) {
              if ($option.find('.passenger_price-old').length) {
                $option.find('.passenger_price-old').html('£' + $this.originalPrice)
              } else {
                $option.find('.passenger_price').before('<span class="passenger_price passenger_price-old">£' + $this.originalPrice + '</span>')
              }
            } else {
              $option.find('.passenger_price-old').remove()
            }

            selectDateModal.updateTotal()
          }

          // Initialize
          $this.init = function () {
            $option.find('.passenger_quantity-select').on('change', function () {
              $this.quantity = Number($(this).val())

              if (selectDateModal.passengerQuantity() > 0) {
                selectDateModal.enableBasket(false)
                selectDateModal.$modal.find('.total_price_value').html('Updating')

                selectDateModal.$modal.find('.passenger_quantity-select').prop('disabled', true)
                selectDateModal.$modal.find('.time-slot_times_options').prop('disabled', true)

                selectDateModal.isAvailable(function (data) {
                  selectDateModal.$modal.find('.passenger_quantity-select').prop('disabled', false)
                  selectDateModal.$modal.find('.time-slot_times_options').prop('disabled', false)

                  if (data.length !== 0) {
                    selectDateModal.updatePrices(data)
                  }

                  selectDateModal.updateTotal()
                  selectDateModal.updateBasketState()
                })
              } else {
                selectDateModal.updateBasketState()
                $this.updateTotal()
              }
            })

            // Update total so option total price has a value
            $this.updateTotal()
          }
        }

        function Ticket($ticket) {
          this.ticketId = $ticket.data('ticket-id') // < Internal Id
          this.ref = $ticket.data('ref')
          this.title = $ticket.data('title')
          this.totalPrice = $ticket.data('total-price')
          this.minBookingQuantity = $ticket.data('min-booking-quantity')
          this.maxBookingQuantity = $ticket.data('max-booking-quantity')
          this.passengerQuantity = $ticket.data('passenger-quantity')
          this.selectedDate = $ticket.data('selected-date')
          this.$ticket = $ticket
          const $this = this

          $this.updateTotal = function (total) {
            // Update Total
            $ticket.find('.ticket_content_info_total_price').html('£' + total.numberFormat(2))

            if ($this.passengerQuantity <= 0) {
              $ticket.find('.ticket_content_info_total').hide()

              $ticket.find('.select-dates').html('Select Dates')
            } else {
              $ticket.find('.ticket_content_info_total').show()

              $ticket.find('.select-dates').html('Modify')
            }

            $this.totalPrice = total
          }

          $this.setPassengerQuantity = function (quantity) {
            $this.passengerQuantity = quantity
          }

          $this.init = function () {
            // When user clicks on 'Select Dates' button, get the content and show in modal
            $ticket.find('.select-dates').on('click', function (e) {
              e.preventDefault()

              selectDateModal.init($this, $(this))
            })

            // Show full details modal
            $ticket.find('.ticket_content_summary_details').on('click', function (e) {
              e.preventDefault()
              const $modal = $('#attraction-tickets-modal')

              let url = '/ajax/attraction-tickets/' + $this.ticketId + '/details'

              // If the URL contains 'manage-my-booking' add it to the url so the session model can identify if it needs to return a 401 if the manage my
              // booking session has expired
              if (window.location.href.indexOf('manage-my-booking') > -1) {
                url += '?manage-my-booking=1'
              }

              $.ajax({
                type: 'GET',
                url,
                cache: false,
                dataType: 'json',
                success: function (data) {
                  $modal.find('.modal-header .modal-title').html(data.title)
                  $modal.find('.modal-body').html(data.body)
                  $modal.modal('show')
                },
                error: function (data) {
                  $modal.modal('hide')

                  // If 401 it means their session has expired.
                  if (data.status === 401) {
                    createAlert('Session expired', 'Your session has expired. Please click <a href="/manage-my-booking/login?expired=1">here</a> to login again.', {
                      onHide: function () {
                        window.location = '/manage-my-booking/login?expired=1'
                      }
                    })
                  } else {
                    createAlert('Error Occured', 'There was an error loading the ticket details. Please try again later.')
                  }
                }
              })
            })
          }
        }

        function Category($category) {
          this.tickets = []
          const $this = this

          $this.init = function () {
            const $tickets = $category.find('.ticket')
            $tickets.each(function () {
              const $ticket = $(this)
              const ticket = new Ticket($ticket)
              ticket.init()

              $this.tickets.push(ticket)
            })

            $category.find('.category_header').on('click', function () {
              const $categoryAccordion = $category.find('.category_accordion')
              if ($categoryAccordion.hasClass('active')) {
                $categoryAccordion.removeClass('active')
              } else {
                $categoryAccordion.addClass('active')
              }

              $category.find('.category_content').slideToggle()
            })
          }
        }

        function Extra($extra) {
          this.type = $extra.data('type')
          this.title = $extra.data('title')
          this.price = Number($extra.data('price'))
          this.selected = $extra.data('selected')
          this.limitDays = $extra.data('limit-days')
          this.$extra = $extra
          const $this = this

          $this.showPomModal = function (redirectUrl) {
            const description = $('#pom-read-more-modal .modal-body').html()
            const $selectPomModal = $('#select-pom-modal')

            const checkIsWithinThreshold = function () {
              const categories = checkout.categories
              for (let i = 0; i < categories.length; i++) {
                const category = categories[i]
                const tickets = category.tickets

                for (let j = 0; j < tickets.length; j++) {
                  const ticket = tickets[j]
                  const selectedDate = ticket.selectedDate

                  if (selectedDate) {
                    const date = new Date(selectedDate)
                    const today = new Date()
                    const diff = Math.abs(date.getTime() - today.getTime())
                    const diffDays = Math.ceil(diff / (1000 * 3600 * 24))

                    if (diffDays <= $this.limitDays) {
                      return true
                    }
                  }
                }
              }

              return false
            }

            const withinThreshold = checkIsWithinThreshold()

            if (withinThreshold == true) {
              if ($this.selected == true) {
                $selectPomModal.find('.content').html('Since you have selected a ticket for a date within the next ' + $this.limitDays + ' days, we cannot offer you a ' + $this.title + '. Please contact us if you have any questions.')
                $selectPomModal.find('.add-pom').addClass('hidden')
                $selectPomModal.find('.no-pom').removeClass('hidden')
              } else {
                window.location.href = redirectUrl
                return
              }
            } else if ($this.selected == false) {
              $selectPomModal.find('.content').html(description)
              $selectPomModal.find('.add-pom').removeClass('hidden')
              $selectPomModal.find('.no-pom').addClass('hidden')
            } else {
              window.location.href = redirectUrl
              return
            }

            $selectPomModal.find('.modal-body h2').text($this.title)

            $selectPomModal.modal('show')

            $('.add-pom').on('click', function () {
              if ($(this).data('action') === 'yes') {
                // Trigger select
                $extra.find('.pom-select').val(1).trigger('change')

                $('#select-pom-modal').modal('hide')
              } else {
                window.location.href = redirectUrl
              }
            })

            $('.no-pom').on('click', function () {
              if ($(this).data('action') === 'close') {
                $('#select-pom-modal').modal('hide')
              } else {
                window.location.href = redirectUrl
              }
            })
          }

          $this.init = function () {
            switch ($this.type) {
              case 'pom':
                $extra.find('.pom-select').on('change', function () {
                  $this.selected = $(this).val()

                  const bookingReference = $('.ticket-container').data('ref')
                  const productType = $('.ticket-container').data('product-type')
                  let url = '/checkout/ajaxAndPostMethods'
                  const paramsProduct = productType

                  if (bookingReference) {
                    url += '/' + bookingReference
                  }

                  // If the URL contains 'manage-my-booking' add it to the url so the session model can identify if it needs to return a 401 if the manage my
                  // booking session has expired
                  if (window.location.href.indexOf('manage-my-booking') > -1) {
                    url += '?manage-my-booking=1'
                  }

                  $.ajax({
                    type: 'POST',
                    url,
                    dataType: 'json',
                    data: {
                      product: 'tickets-extras',
                      params_product: paramsProduct,
                      type: 'pom',
                      selected: $(this).val()
                    },
                    success: function (data) {
                      // Update Cart
                      $('#checkoutCartArea').html(data.basketHTML)

                      // Rerender the checkout
                      checkout.render()
                    },
                    error: function (data) {
                      // If 401 it means their session has expired.
                      if (data.status === 401) {
                        createAlert('Session expired', 'Your session has expired. Please click <a href="/manage-my-booking/login?expired=1">here</a> to login again.', {
                          onHide: function () {
                            window.location = '/manage-my-booking/login?expired=1'
                          }
                        })
                      } else {
                        createAlert('Error Occured', 'There was an error processing your request. Please try again later.')
                      }
                    }
                  })
                })

                $extra.find('.peace-of-mind-protection_read-more').on('click', function () {
                  $('#pom-read-more-modal').modal('show')
                })

                break
              case 'book':
                $extra.find('button').on('click', function () {
                  $('#free-guide-book-modal').modal('show')
                })
                break
            }
          }
        }

        function Extras() {
          this.extras = []
          this.pomExtra = null
          this.bookExtra = null
          const $this = this

          $this.init = function () {
            const $extras = $('.extra')

            $extras.each(function (extra) {
              const $extra = $(this)
              var extra = new Extra($extra)
              extra.init()

              if (extra.type === 'pom') {
                $this.pomExtra = extra
              } else if (extra.type === 'book') {
                $this.bookExtra = extra
              }

              $this.extras.push(extra)
            })
          }
        }

        function Checkout() {
          this.categories = []
          this.$checkOut = $('.checkout_info')
          this.$checkoutButton = $('.checkout_button')
          this.$checkoutInfo = $('.checkout_info')
          this.$checkoutActions = $('.checkout_actions')
          this.$checkoutTotal = $('.checkout_actions_total')
          this.ticketsOnly = this.$checkoutButton.data('tickets-only')
          this.extras = null
          this.totalPrice = 0.00
          this.ticketTotalPrice = 0.00
          this.passengerQuantity = 0
          const $this = this

          $this.init = function () {
            const $categories = $('.category')
            $categories.each(function () {
              const $category = $(this)
              const category = new Category($category)
              category.init()

              $this.categories.push(category)
            })

            $this.$checkoutButton.on('click', function () {
              const url = $(this).data('url')

              const pomExtra = $this.extras.pomExtra

              if (pomExtra) {
                // Check if pom is selected, and if there's no passengers, then show alert to user and remove the pom
                if ($this.passengerQuantity <= 0) {
                  if (pomExtra.selected == true) {
                    createAlert(pomExtra.title, `${pomExtra.title} has been removed from your basket as no tickets have been selected.`, {
                      onHide: function () {
                        window.location.href = url
                      }
                    })

                    return
                  }
                } else {
                  pomExtra.showPomModal(url)
                  return
                }
              }

              window.location.href = url
            })

            $this.extras = new Extras()
            $this.extras.init()

            $this.render()
          }

          // Render the checkout overview page
          $this.render = function () {
            $this.$checkOut.empty()
            $this.totalPrice = 0.00
            $this.ticketTotalPrice = 0.00
            $this.passengerQuantity = 0
            const tickets = []

            for (var i = 0; i < $this.categories.length; i++) {
              for (let h = 0; h < $this.categories[i].tickets.length; h++) {
                const ticket = $this.categories[i].tickets[h]
                tickets[ticket.ticketId] = ticket
              }
            }

            Object.entries(tickets).forEach(([_, ticket]) => {
              if (ticket.$ticket.find('.ticket_content_info_total').length) {
                $this.totalPrice += ticket.totalPrice
                $this.ticketTotalPrice += ticket.totalPrice
                $this.passengerQuantity += ticket.passengerQuantity
              }
            })

            for (var i = 0; i < $this.extras.extras.length; i++) {
              const extra = $this.extras.extras[i]
              if (extra.selected == true) {
                $this.totalPrice += extra.price
              }
            }

            // Get the Basket HTML, this will populate the checkout info
            // TODO; Build response from server to populate the checkout info
            {
              const $basket = $('#checkoutCartArea')
              const $attractionTicketInfo = $basket.find('#attraction-ticketsCollapse')
              $this.$checkoutInfo.html($attractionTicketInfo.html())
              $this.$checkoutInfo.find('.qty').prepend('×')
              $this.$checkoutInfo.find('.item:contains("Attraction Tickets")').each(function () {
                const $this = $(this)
                $this.closest('.row').remove()
              })

              $this.$checkoutInfo.find('.row:contains("Edit")').each(function () {
                const $this = $(this)
                $this.closest('.row').remove()
              })
            }

            if ($this.ticketsOnly) {
              $this.enableCheckout($this.ticketTotalPrice > 0)
            }

            $this.showCheckoutInfo($this.passengerQuantity > 0 || $this.totalPrice > 0)
            $this.$checkoutTotal.html('£' + $this.totalPrice.numberFormat(2))
          }

          // Enable or disable checkout button
          $this.enableCheckout = function (enable) {
            if (enable) {
              $this.$checkoutButton.attr('disabled', false)
            } else {
              $this.$checkoutButton.attr('disabled', true)
            }
          }

          // Show Checkout Info
          $this.showCheckoutInfo = function (show) {
            if (show) {
              $this.$checkoutInfo.show()
            } else {
              $this.$checkoutInfo.hide()
            }
          }

          // Add row
          $this.addRow = function (title, totalPrice) {
            if (!isNaN(totalPrice)) {
              totalPrice = '£' + totalPrice.toFixed(2)
            }

            $this.$checkOut.append('<div class="row">' +
              '<div class="col-xs-6 col-md-offset-2 col-md-6 col-lg-offset-4 col-lg-5 checkout_info_label">' + title + '</div>' +
              '<div class="col-xs-3 col-md-2 col-lg-1 text-right checkout_info_price">× 1</div>' +
              '<div class="col-xs-3 col-md-2 col-lg-2 text-right checkout_info_price">' + totalPrice + '</div>' +
              '</div>'
            )
          }
        }

        // Add smooth scrolling to html element
        $('html').css({
          'scroll-behavior': 'smooth'
        })

        const $menu = $('.checkout_attraction-tickets .menu')
        const $menuItems = $menu.find('.menu_item')

        $menuItems.on('click', function () {
          const $this = $(this)
          const $menuItem = $this.closest('.menu_item')

          $menuItems.removeClass('menu_item-active')

          if ($menuItem.hasClass('menu_item-active')) {
            $menuItem.removeClass('menu_item-active')
          } else {
            $menuItem.addClass('menu_item-active')

            // Open the category
            const href = $menuItem.find('a').attr('href')
            const $category = $(href)

            // If category is not open, open the category
            if (!$category.find('.category_accordion').hasClass('active')) {
              $category.find('.category_header').trigger('click')
            }
          }
        })

        // Get anchor tag from URL
        const url = window.location.href
        const anchor = url.split('#')[1]

        if (anchor) {
          const $anchor = $menu.find('a[href="#' + anchor + '"]')
          if ($anchor.length) {
            $anchor.closest('.menu_item').addClass('menu_item-active')
            const $category = $(`#${anchor}`)

            // If category is not open, open the category
            if (!$category.find('.category_accordion').hasClass('active')) {
              $category.find('.category_header').trigger('click')
            }
          }
        }

        analyticsEvent('view_tickets')
      }
    },

    checkout_your_details: {
      init: function () {
        // postcode lookup below
        const PostcodeLookupClass = new PostcodeLookup()
        PostcodeLookupClass.setupFormListeners()

        // leaving address date
        $.extend($.fn.pickadate.defaults, {
          format: 'dd/mm/yyyy',
          formatSubmit: 'yyyy-mm-dd',
          hiddenName: true,
          clear: '',
          today: '',
          onClose: function () {
            this.$holder.blur() /* fixes bug - feature? https://github.com/amsul/pickadate.js/issues/160 stops the existing picker after being closed still be in focus, if you close the picker by selecting a date and then move from another tab back to this one it re-opens - this releaves the focus onClose */

            /* on close reset the selected value back to what is selected as we can navigate to a different month and close the picker - once reopened it would display the month we navigated to rather than the date that has been set - these 3 lines reset it on close */
            const selectMonthYear = this.get('select', 'yyyy-mm')
            const highlightMonthYear = this.get('highlight', 'yyyy-mm')
            if (selectMonthYear !== highlightMonthYear) {
              this.set({
                select: this.get('select')
              })
            }
          }
        })

        const $leavingdateField = $('#leavingdate')
        const earliest = moment($leavingdateField.attr('data-earliest'))
        const latest = moment($leavingdateField.attr('data-latest'))
        $leavingdateField.pickadate({
          container: '#arrival-container',
          min: earliest.toDate(),
          max: latest.toDate()
        })

        // copy lead passenger details to lead driver
        $('body').on('click', '#leadpassenger', function () {
          if ($('#leadpassenger').is(':checked')) {
            if ($(this).data('prefilled') === +true) {
              $('#driver_title').val($(this).data('title'))
              $('#driver_title').trigger('chosen:updated')

              $('#driver_forename').val($(this).data('forename'))
              $('#driver_surname').val($(this).data('surname'))

              if ($(this).data('dob') === +true) {
                $('#driver_dob_d').val($(this).data('dob-d'))
                $('#driver_dob_d').trigger('chosen:updated')
                $('#driver_dob_m').val($(this).data('dob-m'))
                $('#driver_dob_m').trigger('chosen:updated')
                $('#driver_dob_y').val($(this).data('dob-y'))
              }
            } else {
              $('#driver_title').val($('#title').val())
              $('#driver_title').trigger('chosen:updated')
              $('#driver_forename').val($('#forename').val())
              $('#driver_surname').val($('#surname').val())
              if ($('#leadpassengerflight').length) { // if we have flights - and the useleadpassengerdetails is checked
                if ($('#leadpassengerflight').is(':checked')) {
                  $('#driver_dob_d').val($('#adult_0_30_dob_d').val())
                  $('#driver_dob_d').trigger('chosen:updated')
                  $('#driver_dob_m').val($('#adult_0_30_dob_m').val())
                  $('#driver_dob_m').trigger('chosen:updated')
                  $('#driver_dob_y').val($('#adult_0_30_dob_y').val())
                }
              }
            }
          } else {
            $('#driver_title').val('')
            $('#driver_title').trigger('chosen:updated')
            $('#driver_forename').val('')
            $('#driver_surname').val('')
            $('#driver_dob_d').val('')
            $('#driver_dob_d').trigger('chosen:updated')
            $('#driver_dob_m').val('')
            $('#driver_dob_m').trigger('chosen:updated')
            $('#driver_dob_y').val('')
          }
        })

        // copy lead passenger details to flight adult 1
        $('body').on('click', '#leadpassengerflight', function () {
          if ($('#leadpassengerflight').is(':checked')) {
            $('#adult_0_30_title').val($('#title').val())
            $('#adult_0_30_title').trigger('chosen:updated')
            $('#adult_0_30_forename').val($('#forename').val())
            $('#adult_0_30_surname').val($('#surname').val())
          } else {
            $('#adult_0_30_title').val('')
            $('#adult_0_30_title').trigger('chosen:updated')
            $('#adult_0_30_forename').val('')
            $('#adult_0_30_surname').val('')
          }
        })

        const $ticketSections = $('.ticket-section')
        const sections = []

        function TicketSection($ticketSection) {
          this.id = $ticketSection.data('id')
          this.$selectTitles = $ticketSection.find('.ticket-title')
          this.$inputForenames = $ticketSection.find('.ticket-forename')
          this.$inputSurnames = $ticketSection.find('.ticket-surname')
          this.$useLeadPassenger = $ticketSection.find('.lead-passenger-tickets')

          const onUseLeadPassengerChange = (e) => {
            const $target = $(e.target)

            if ($target.is(':checked')) {
              if ($target.data('prefilled')) {
                this.$selectTitles.first().val($target.data('title'))
                this.$selectTitles.first().trigger('chosen:updated')

                this.$inputForenames.first().val($target.data('forename'))
                this.$inputSurnames.first().val($target.data('surname'))
              } else {
                this.$selectTitles.first().val($('#title').val())
                this.$selectTitles.first().trigger('chosen:updated')

                this.$inputForenames.first().val($('#forename').val())
                this.$inputSurnames.first().val($('#surname').val())
              }
            } else {
              this.$selectTitles.first().val('')
              this.$selectTitles.first().trigger('chosen:updated')
              this.$inputForenames.first().val('')
              this.$inputSurnames.first().val('')
            }
          }

          const onInputChange = (e) => {
            if (this.id === sections.length) {
              return
            }

            const $target = $(e.target)
            let inputType = ''

            if ($target.hasClass('ticket-forename')) {
              inputType = '$inputForenames'
            } else if ($target.hasClass('ticket-surname')) {
              inputType = '$inputSurnames'
            } else {
              inputType = '$selectTitles'
            }

            for (let i = this.id + 1; i < sections.length; i++) {
              const section = sections[i]

              const inputId = $target.data('id')

              const $inputField = section[inputType].filter((index, input) => {
                return $(input).data('id') === inputId
              })

              if ($inputField.length) {
                if (inputType === '$selectTitles') {
                  $inputField.val($target.val()).change()
                  $inputField.trigger('chosen:updated')
                } else {
                  $inputField.val($target.val())
                }
              }
            }
          }

          this.$inputForenames.on('input', onInputChange)
          this.$inputSurnames.on('input', onInputChange)
          this.$selectTitles.on('change', onInputChange)
          this.$useLeadPassenger.on('change', onUseLeadPassengerChange)
        }

        if ($ticketSections.length) {
          $ticketSections.each(function () {
            sections.push(new TicketSection($(this)))
          })
        }
      }
    },

    payment_form: {
      init: function () {
        let amount
        let amountFormatted
        const displayTheAmount = function () {
          amount = parseFloat($('input[type=radio][name=pay-amount]:checked').val())
          amountFormatted = amount.numberFormat(2)
          $('#amount-display').html(amountFormatted)
          const $makePaymentButton = $('#make-payment-button')
          const bookRef = $makePaymentButton.data('bookref')
          const paymentToken = $makePaymentButton.data('payment-token')
          let link = '/payment-create-axcess/' + bookRef + '/' + amount + '/' + paymentToken
          if ($makePaymentButton.data('payment-source')) {
            link += '/' + $makePaymentButton.data('payment-source') // append the payment form source if it exists as a data attribute on the button
          }

          // If there's pending products which needs to be set active on payment, we need
          // to also pass the data to the url
          // The pending products data is base64 encoded
          if ($makePaymentButton.data('pending-products')) {
            link += `?pendingProducts=${$makePaymentButton.data('pending-products')}`
          }

          $makePaymentButton.attr('href', link)
        }
        displayTheAmount()

        $('input[type=radio][name=pay-amount]').change(function () {
          switch (this.id) {
            case 'pay-type-CUS':
              $('#custom-area').fadeIn()
              $('#pay-form-submit-area').fadeOut()
              break
            default:
              $('#custom-area').fadeOut()
              $('#pay-form-submit-area').fadeIn()
              displayTheAmount()
          }
        })

        $('body').on('click', '.custom-amount-button', function (e) {
          e.preventDefault()
          $payThisAmountButton = $(this)
          $payTypeCusRadio = $('#pay-type-CUS')
          $customAmountInput = $('#custom-amount')
          const amounts = $payTypeCusRadio.data('amount').split(';')
          const minAmount = parseFloat(amounts[0])
          const maxAmount = parseFloat(amounts[1])
          const enteredCustomAmount = $customAmountInput.val()
          $('#custom-area').removeClass('has-error')
          if (isNaN(enteredCustomAmount)) {
            // error not a number entered
            $('#custom-area .help-block.with-errors').html('Custom amount must be a number')
            $('#custom-area').addClass('has-error')
          } else {
            // its a number - do stuff
            if (enteredCustomAmount < minAmount || enteredCustomAmount > maxAmount) {
              $('#custom-area .help-block.with-errors').html('Custom amount must be between the amounts shown above')
              $('#custom-area').addClass('has-error')
            } else {
              // amount is good
              $payTypeCusRadio.val(enteredCustomAmount)
              $customAmountInput.attr('disabled', 'disabled')
              $('#custom-amount-clear').removeClass('hidden')
              $payThisAmountButton.fadeOut()
              $('#pay-form-submit-area').fadeIn()
              displayTheAmount()
            }
          }
        })

        $('body').on('click', '#clear-custom-amount', function (e) {
          e.preventDefault()
          $('#custom-amount-clear').addClass('hidden')
          $('#custom-amount').val('')
          $('#custom-amount').removeAttr('disabled')
          $('.custom-amount-button').fadeIn()
          $('#pay-form-submit-area').fadeOut()
        })

        $('body').on('click', '#make-payment-button', function (e) {
          e.preventDefault()
          $('.payment-form-modal').modal('show')
        })

        $('.payment-form-modal').on('show.bs.modal', function (e) {
          const _url = $('#make-payment-button').attr('href')
          $('.payment-form-modal .modal-body').html('<iframe height="650px" width="100%" src="' + _url + '" frameBorder="0"></iframe>')
        })

        $('.confirm-skip-payment').on('click', function (e) {
          e.preventDefault()

          createModal('Are you sure?', `
              <div class="text-center">
                <i style="color:#ffc107;" class="fa fa-warning fa-4x"></i>
                <p><b>Are you sure you want to skip payment?</b></p>
                <p>If the booking is in a booked status: this will set the product(s) to <b>"Active"</b> status, meaning the system will
                  attempt to book the added product(s).
                </p>
              </div>
            `, {
            customFooter: `
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <a class="btn btn-primary skip-payment" href="${$(this).attr('href')}">Proceed</a>
            `
          })
        })

        analyticsEvent('purchase')
      }
    },

    payment_declined: {
      init: function () {
        $('.payment-declined-modal').modal('show')
      }
    },

    about_florida_theme_parks_theme_park_parent_theme_park_child: {
      init: function () {
        $('.character').matchHeight()
      }
    },

    about_florida_communities_communities_parent: {
      init: function () {
        $('.community').matchHeight()
      }
    },

    location_search_autocomplete: {
      init: function () {
        // Ajax live search stuff will probably go in here

        /* Add cursor control here
        https://stackoverflow.com/questions/17810746/use-up-and-down-arrows-for-autocomplete-search
        */

        const displayLocationSearchResults = function (jsonResults, locationElementId) {
          const results = $.parseJSON(jsonResults)
          let shtml = '<ul><li><strong>Sorry no location matches</strong></li></ul>'
          if (results.length) {
            shtml = '<ul>'
            for (const i in results) {
              const result = results[i]
              shtml += '<li><a href="" class="searchLocationResult" data-element-id="' + locationElementId + '" data-location-id="' + result.code + '">'
              shtml += result.name
              if (locationElementId.includes('flight')) {
                shtml += ' (' + result.code + ')' // code part of the name for the carhire if airport searched, as code is the id|tlc
              }
              shtml += '</a></li>'
            }
            shtml += '</ul>'
          }
          $('#' + locationElementId + '_results').html(shtml)
          $('#' + locationElementId + '_results').fadeIn()
        }

        const cachedSearches = {}
        const searchLocations = function (locationElementId, locationSearchServiceUrl, searchString) {
          const qTerm = searchString
          // if(locationElementId.includes('carHire')){ // deprecated - affordable we needed to also supply city or airport
          //   var locationElementIdParts = locationElementId.split('_');
          //   var way = locationElementIdParts[1];
          //   var qType = $('[name="'+way+'_type"]:checked').val();
          //   qTerm += '_'+qType;
          // }
          const upperCaseSearchString = qTerm.toUpperCase()
          if (qTerm !== '') {
            if (upperCaseSearchString in cachedSearches) {
              // console.log('cached result');
              displayLocationSearchResults(cachedSearches[upperCaseSearchString], locationElementId)
            } else {
              $.ajax({
                type: 'GET',
                url: locationSearchServiceUrl,
                data: { locTerm: encodeURI(qTerm) },
                cache: false,
                success: function (jsonResults) {
                  // console.log('ajax result');
                  cachedSearches[upperCaseSearchString] = jsonResults
                  displayLocationSearchResults(jsonResults, locationElementId)
                }
              })
            }
          }
          return false
        }

        $('body').on('keyup', '.location-search', function (e) {
          const $searchElement = $(this)
          const locationSearchServiceUrl = $searchElement.data('locationSearchServiceUrl')
          const locationElementId = $searchElement.data('elementId')
          clearTimeout($searchElement.data('timer'))
          // Set Search String
          const search_string = $searchElement.val()
          // Do Search
          if (search_string.length < 3) {
            $('#' + locationElementId + '_results').fadeOut()
          } else {
            $searchElement.data('timer', setTimeout(function () {
              searchLocations(locationElementId, locationSearchServiceUrl, search_string)
            }, 100))
          }
        })

        $('body').on('click', '.searchLocationResult', function (e) {
          e.preventDefault()
          const $resultClicked = $(this)
          const elementId = $resultClicked.data('elementId')
          const locationId = $resultClicked.data('locationId')
          // if(elementId.includes('flight')){
          $('#' + elementId).attr('value', locationId) // set the form value to the locationId
          // } else {
          // car hire
          // var locationIdParts = locationId.split('|');
          // var locId = locationIdParts[0];
          // var locTlc = locationIdParts[1];
          // $("#"+elementId+'_locId').attr("value",locId);
          // $("#"+elementId+'_locTlc').attr("value",locTlc);
          // }
          $('#' + elementId).trigger('change') // make the change event fire on the hidden element as change event not triggered automatically on hidden element
          $('#' + elementId + '_search').addClass('hidden') // hide the input field
          $('#' + elementId + '_results').fadeOut() // empty the results area
          $('#' + elementId + '_searched').removeClass('hidden') // show the area that contains the result
          $('#' + elementId + '_searched .result').html($resultClicked.html()) // populate the result with the text of the search result
        })

        resetAutoCompleteForm = function (elementId) {
          // if(elementId.includes('flight')){
          $('#' + elementId).attr('value', '') // reset the value in the form
          $('#' + elementId).trigger('change') // make the change event fire on the hidden element as change event not triggered automatically on hidden element
          // } else {
          // carhire
          // $("#"+elementId+'_locId').attr("value","");
          // $("#"+elementId+'_locTlc').attr("value","");
          // $("#"+elementId+'_locId').trigger("change");
          // $("#"+elementId+'_locTlc').trigger("change");
          // }
          $('#' + elementId + '_search').val('') // reset the text in the search area
          $('#' + elementId + '_search').removeClass('hidden') // show the input field that initiates the search
          $('#' + elementId + '_searched').addClass('hidden') // hide the area that contains the result
          $('#' + elementId + '_searched .result').html('') // empty the result thats displayed
          $('#' + elementId + '_results').html('') // empty the results area
        }

        $('body').on('click', '.clearSearchDestination', function (e) {
          e.preventDefault()
          const $resultClicked = $(this)
          const elementId = $resultClicked.data('elementId')
          resetAutoCompleteForm(elementId)
        })
      }
    },

    /**
    * For pages where we need travel dates user-selectable (search form, car hire .etc)
    */

    travel_dates_picker: {
      init: function () {
        // date and time picker documentation http://amsul.ca/pickadate.js/api/
        // moment.js docs https://momentjs.com/docs/#/parsing/

        const $arrivalField = $('#arrival')

        const earliest = moment($arrivalField.attr('data-earliest'))
        const latest = moment($arrivalField.attr('data-latest'))

        $.extend($.fn.pickadate.defaults, {
          format: 'dd/mm/yyyy',
          formatSubmit: 'yyyy-mm-dd',
          hiddenName: true,
          clear: '',
          today: '',
          selectYears: true,
          onClose: function () {
            this.$holder.blur() /* fixes bug - feature? https://github.com/amsul/pickadate.js/issues/160 stops the existing picker after being closed still be in focus, if you close the picker by selecting a date and then move from another tab back to this one it re-opens - this releaves the focus onClose */

            /* on close reset the selected value back to what is selected as we can navigate to a different month and close the picker - once reopened it would display the month we navigated to rather than the date that has been set - these following lines reset it on close if the month and year is different from the selected value */
            const selectMonthYear = this.get('select', 'yyyy-mm')
            const highlightMonthYear = this.get('highlight', 'yyyy-mm')
            if (selectMonthYear !== highlightMonthYear) {
              this.set({
                select: this.get('select')
              })
            }
          }
        })

        const $departureField = $('#departure')
        const hasDepartureField = $departureField.length

        if (hasDepartureField) {
          $departureField.pickadate({
            container: '#departure-container'
          })
        }

        const setupDepartureField = function (eventTriggerType) {
          if (!hasDepartureField) {
            return
          }
          if (eventTriggerType == 'onSet') {
            const selected = $arrivalField.pickadate('picker').get('select', 'yyyy-mm-dd')
            const selectedMoment = moment(selected)
            if ($arrivalField.attr('data-arrival-field-previous-value') !== selected) {
              $departureField.pickadate('picker').set({
                min: selectedMoment.toDate(),
                select: selectedMoment.toDate()
              })
              $departureField.pickadate('picker').clear()
            }
          }

          const minDays = $departureField.attr('data-mindays')
          const maxDays = ($departureField.attr('data-maxdays') - 1)
          const arrival = $arrivalField.pickadate('picker').get('select', 'yyyy-mm-dd')
          $arrivalField.attr('data-arrival-field-previous-value', arrival)
          const ealiestDeparture = moment(arrival).clone().add(minDays, 'days')
          const latestDeparture = ealiestDeparture.clone().add(maxDays, 'days')
          $departureField.pickadate('picker').set({
            min: ealiestDeparture.toDate(),
            max: latestDeparture.toDate()
          })
        }

        const setDepartureDateText = function () {
          const $setDepartureDateTextContainer = $('#searchFormDepartureDateText-container')
          if (!$setDepartureDateTextContainer.length) {
            return
          }
          const nights = $('#nights').val()
          $setDepartureDateTextContainer.removeClass('hidden')
          const arrival = moment($arrivalField.pickadate('picker').get('select', 'yyyy-mm-dd')).clone()
          const outDate = arrival.add(nights, 'days').format('ddd Do MMMM YYYY')
          $('.searchFormDepartureDateText').html('Depart: ' + outDate)
        }

        $arrivalField.pickadate({
          container: '#arrival-container',
          min: earliest.toDate(),
          max: latest.toDate(),
          onSet: function () {
            setupDepartureField('onSet')
            setDepartureDateText()
          },
          onStart: function () {
            setupDepartureField('onStart')
            setDepartureDateText()
          }
        })

        $('#nights').on('change', function () {
          setDepartureDateText()
        })
      }
    },

    travel_times_picker: {
      init: function () {
        $.extend($.fn.pickatime.defaults, {
          interval: 15,
          format: 'HH:i',
          formatSubmit: 'HH-i',
          hiddenName: true,
          onClose: function () {
            this.$holder.blur() /* fixes bug - feature? https://github.com/amsul/pickadate.js/issues/160 stops the existing picker after being closed still be in focus, if you close the picker by selecting a date and then move from another tab back to this one it re-opens - this releaves the focus onClose */

            /* on close reset the selected value back to what is selected as we can navigate to another time which would look like that is then selected if the picker was reopened - by setting selected back to the set version it then has that in view when reopned */
            const setTime = this.get('select')
            this.set({
              select: setTime
            })
          }
        })

        const $arrivalTimeField = $('#arrivaltime')
        const $departureTimeField = $('#departuretime')

        $arrivalTimeField.pickatime({
          container: '#arrival-time-container'
        })

        $departureTimeField.pickatime({
          container: '#departure-time-container'
        })
      }
    },

    /**
    * For pages where a 'back to top' link is required
    */
    go_to_navigation: {
      init: function () {
        /**
        * ------------------------
        * Stuff to do on page load
        * ------------------------
        */

        /**
        * Inter page navigation
        */
        $('.go-to').on('click', function (e) {
          e.preventDefault()
          const target = $(this).attr('href')

          $(target).animatescroll()
        })
      }
    },

    /**
    * For pages with the responsive search / filter windows
    */
    responsive_search_filter: {
      init: function () {
        /**
        * ------------------------
        * Stuff to do on page load
        * ------------------------
        */

        /**
        * Open / close cart / responsive search and filter menus
        * @param windowType
        */
        function openCloseResponsiveWindow(windowType) {
          /**
          * This function might seem like it operates in reverse. It doesn't. Here's the logic:
          *
          *  1.  Page loads, and #shoppingCartContents has a class of 'closed' by default.
          *
          *  2.  When a user does something to invoke this function (like clicking a button),
          *      it checks the cart's current state, based on the class applied (opened or closed).
          *
          *  3.  If the cart is currently closed (has the 'closed' class), we will open the cart.
          *      If the cart is currently open (has the class 'opened'), we will close the cart.
          *
          *  4.  Once an action has been performed (opened or closed), we apply the class to reflect it's
          *      current state.
          *
          *  So - page load. Cart is closed and has the "closed" class.
          *  We click the button to open the cart. JS sees that cart has "closed" class.
          *  JS sets overflow to scroll, changes the text to "Close cart" and, finally, set the class to "opened".
          *
          *
          * Make sense? :)
          */

          let container
          let windowContext
          const viewText = $('.view-text')
          const closer = $('.cart-closer')
          const icon = $('.cartIcon')
          let iconClass

          if ($(window).width() < 992) {
            $('.open-tab').animate({
              opacity: 0
            }, 400)
          }

          if ($('body').hasClass('responsive-cart-window')) {
            if (windowType === 'cart') {
              container = $('#shoppingCartContents')
            } else {
              container = $(windowType)
            }

            windowContext = 'cart'
            iconClass = 'fa-shopping-cart'
          }

          if ($('body').hasClass('responsive-search-filter-window')) {
            if (windowType === 'search') {
              container = $('#mobileSearchFormContainer')
              iconClass = 'fa-search'
            }

            if (windowType === 'filter') {
              container = $('#mobileFilterContainer')
              iconClass = 'fa-filter'
            }

            windowContext = 'window'
          }

          if (container.hasClass('opened')) {
            viewText.text('View ' + windowContext)
            closer.remove()
            $('body').css('overflow-y', 'auto')
          }

          if (container.hasClass('closed')) {
            viewText.text('Close ' + windowContext)
            $('body').css('overflow-y', 'hidden')

            if ($('body').hasClass('responsive-cart-window')) {
              $('body').append('<div class="cart-closer"></div>')
            }
          }

          icon.toggleClass('fa-times-circle').toggleClass(iconClass)
          container.toggleClass('opened').toggleClass('closed')
          $('html').toggleClass('mobile-filter-visible')

          if ($('body').hasClass('responsive-cart-window')) {
            $('body').toggleClass('mobile-filter-visible').toggleClass('knock-out')
          }

          if ($(window).width() < 992) {
            $('.open-tab').animate({
              opacity: 1
            }, 400)
          }
        }

        if ($('body').hasClass('responsive-cart-window')) {
          // Press escape key to close the cart
          Mousetrap.bind(['esc'], function (e) {
            if ($('body').hasClass('knock-out')) {
              openCloseResponsiveWindow('.cart-contents.opened')
            }
          })

          // Press CTRL + K or CMD + K to open/close cart
          Mousetrap.bind(['command+k', 'ctrl+k'], function (e) {
            if ($('body').hasClass('knock-out')) {
              openCloseResponsiveWindow('.cart-contents.opened')
            } else {
              openCloseResponsiveWindow('.cart-contents.closed')
            }

            return false
          })
        }

        $('body').on('click', '.open-tab', function () {
          // console.log('clicked');
          if ($('body').hasClass('mobile-filter-visible')) {
            $('#mobile-filter-menu').animate({
              bottom: 0
            }, 400, function () {
              $('body').removeClass('mobile-filter-visible')
            })
          }
          openCloseResponsiveWindow($(this).attr('data-target-type'))
        })

        $('body').on('click', '.clear-button', function (e) {
          e.preventDefault()
          $('.open-tab[data-target-type="filter"]').trigger('click')
        })

        $('body.villas').on('click', '.search-villas-button', function (e) {
          e.preventDefault()
          $('.open-tab[data-target-type="search"]').trigger('click')
        })
        // change default search button name if used on villas page as it just closes instead of performing a search - on a form value change it changes to "show xx villas anyway"
        $('body.villas .search-villas-button').html('Close Search')

        $('#mobile-search-button').on('click', function (e) {
          e.preventDefault()

          if (!$('body').hasClass('mobile-filter-visible')) {
            $('#mobile-filter-menu').animate({
              bottom: '-60px'
            }, 400, function () {
              $('body').addClass('mobile-filter-visible')
              openCloseResponsiveWindow('search')
            })
          }
        })

        $('#mobile-filter-button').on('click', function (e) {
          e.preventDefault()

          if (!$('body').hasClass('mobile-filter-visible')) {
            $('#mobile-filter-menu').animate({
              bottom: '-60px'
            }, 400, function () {
              $('body').addClass('mobile-filter-visible')
              openCloseResponsiveWindow('filter')
            })
          }
        })
      }
    },

    /**
    * For pages that contain the mailing list form - this runs the ajax to subscribe them or return the errors
    */
    mailist_form: {
      init: function () {
        /**
        * ------------------------
        * Stuff to do on page load
        * ------------------------
        */

        $('.mailinglistform').on('submit', function (e) { // use on if jQuery 1.7+
          e.preventDefault() // prevent form from submitting
          const $form = $(this)
          const formValues = $form.serialize()
          const formAction = $form.attr('action')

          $.ajax({
            type: 'POST',
            url: formAction,
            cache: false,
            data: formValues,
            success: function (response) {
              const oResponse = $.parseJSON(response)
              $('.mailinglistform .form-group').removeClass('has-error')
              switch (oResponse.status) {
                // Success
                case 'success':
                  $('.mailinglistform').parent().html(oResponse.html)
                  $('.debbies_sameheight').matchHeight()
                  break

                // Validation errors
                case 'error':
                  $('.mailinglistform .form-group').removeClass('has-error')
                  for (const fieldName in oResponse.formErrors) {
                    const fieldError = oResponse.formErrors[fieldName]
                    $('.mailinglistform .form-group.' + fieldName).addClass('has-error')
                    $('.mailinglistform .form-group.' + fieldName + ' .control-label').html(fieldError)

                    if (fieldName == 'g-recaptcha-response') {
                      disableMailingListButton()
                      alert('Sorry unable to verify the reCAPTCHA, please try again.')
                      grecaptcha.reset()
                    }
                  }
                  $('.debbies_sameheight').matchHeight()
                  break
              }
            },

            // Ajax route broken
            error: function (response) {
              // console.log(response.responseText);
            }
          })
        })
      }
    },

    /**
    * For pages that contain the send pdf form - this runs the ajax to add it to send pdf queue or return the errors
    */
    send_pdf_form: {
      init: function () {
        /**
        * ------------------------
        * Stuff to do on page load
        * ------------------------
        */
        // the reCAPTCHA script (//www.google.com/recaptcha/api.js) is added to the scripts to load in the footer if recaptcha is included in the bodyClasses
        $('#send-pdf-form').on('submit', function (e) { // use on if jQuery 1.7+
          e.preventDefault() // prevent form from submitting
          const $form = $(this)
          const formValues = $form.serialize()
          const formAction = $form.attr('action')
          const $fieldSet = $form.find('fieldset')
          $fieldSet.attr('disabled', 'disabled')
          $('#send-pdf-form .form-group').removeClass('has-error')
          $('#send-pdf-form .form-group .help-block').addClass('hidden')
          const $submitButton = $form.find('button')
          const $loadingSpinner = $form.find('.loading-spinner')
          $submitButton.addClass('hidden')
          $loadingSpinner.removeClass('hidden')
          $.ajax({
            type: 'POST',
            url: formAction,
            cache: false,
            data: formValues,
            success: function (response) {
              const oResponse = $.parseJSON(response)

              switch (oResponse.status) {
                // Success
                case 'success':
                  $('#recipientemail').val('') // empty recipient email
                  disableSendTofriendButton() // disable the submit button again as verifying the recaptcha enables it
                  grecaptcha.reset() //
                  $('.send-pdf-modal').modal('hide')
                  // alert("Pdf of this property has been sent");
                  break
                // Validation errors
                case 'error':
                  for (const fieldName in oResponse.formErrors) {
                    const fieldError = oResponse.formErrors[fieldName]
                    const $formGroupElement = $('#send-pdf-form  #' + fieldName + '_group')
                    $formGroupElement.addClass('has-error')
                    const $helpBlockElement = $formGroupElement.find('.help-block')
                    $helpBlockElement.html(fieldError)
                    $helpBlockElement.removeClass('hidden')
                    if (fieldName == 'g-recaptcha-response') {
                      disableSendTofriendButton()
                      alert('Sorry unable to verify the reCAPTCHA, please try again.')
                      grecaptcha.reset()
                    }
                  }
                  break
              }
            },
            // Ajax route broken - validation errors come back in the success handler - TODO should be erroe status code for form validaitn errors 422
            error: function (response) {
              alert('Sorry failed to send PDF - please try again later or if the problem persists please contact us')
            }
          })
            .always(function (data) {
              // similar to finally will be called after error or success
              $fieldSet.removeAttr('disabled')
              // remove loading spinners
              $submitButton.removeClass('hidden')
              $loadingSpinner.addClass('hidden')
            })
        })
      }
    },
    manage_my_booking_auth: {
      init: function () {
        $('.booking-form').on('submit', function (e) {
          e.preventDefault()

          // Remove session expired alert box
          $('.session-expired').remove()

          const $form = $(this)
          const $alert = $form.find('.alert')

          const loading = function (loading) {
            if (loading) {
              $form.find('button').attr('disabled', 'disabled')
              $form.find('.loading-spinner').removeClass('hidden')

              $form.find('.help-block').addClass('hidden')
              $form.find('.form-group').removeClass('has-error')

              $alert.addClass('hidden')
              $alert.removeClass('alert-danger alert-success')
            } else {
              $form.find('button').removeAttr('disabled')
              $form.find('.loading-spinner').addClass('hidden')
            }
          }

          loading(true)

          $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            cache: false,
            data: $form.serialize(),
            dataType: 'json',
            success: function (response) {
              switch (response.action) {
                case 'forgot-password':
                case 'register':
                  $alert.addClass('alert-success')
                  $alert.find('.message').html(response.data.message)
                  $alert.detach().appendTo('.subsections')
                  $alert.removeClass('hidden')

                  $form.addClass('hidden')
                  break
                case 'login':
                  // Redirect user to summary page
                  window.location = '/manage-my-booking/summary'
                  break
              }
            },
            error: function (response) {
              if (response.status == 422) {
                response = response.responseJSON

                if (response.data.validationErrors) {
                  const validationErrors = response.data.validationErrors

                  if (validationErrors.booking) {
                    $alert.addClass('alert-danger')
                    $alert.find('.message').html(validationErrors.booking)
                    $alert.removeClass('hidden')
                  } else {
                    for (const fieldName in validationErrors) {
                      const fieldError = validationErrors[fieldName]

                      const $formGroupElement = $('.' + fieldName + '_group')
                      $formGroupElement.addClass('has-error')

                      const $helpBlockElement = $formGroupElement.find('.help-block')
                      $helpBlockElement.html(fieldError)
                      $helpBlockElement.removeClass('hidden')
                    }
                  }
                }
              } else if (response.status == 401) {
                $alert.addClass('alert-danger')
                $alert.find('.message').html('Sorry we cannot find any booking with those details')
                $alert.removeClass('hidden')
              } else {
                $alert.addClass('alert-danger')
                $alert.find('.message').html('Sorry, there was an error processing your request. Please try again later.')
                $alert.removeClass('hidden')
              }
            },
            complete: function () {
              loading(false)
            }
          })
        })
      }
    },
    manage_my_booking_extras: {
      init: function () {
        const $modal = $('#manage-my-booking-extra-model')
        const $updateButton = $modal.find('.btn-primary')
        const $cancelButton = $modal.find('.cancel-button')
        const $modalLoader = $modal.find('.modal-body__loader')
        const $modalBodyContent = $modal.find('.modal-body-content')

        // store an object to submit to the api when the update button is clicked - declare this outside the select change event so that can update it and the update button clicked can access it
        const updates = {}

        $('.test').on('click', function () {
          $(this).closest('.row').find('button').click()
          // $(this).closest('.content__button').click();
        })

        /**
         * preform the ajax request when the update button is pressed
         */
        $updateButton.on('click', function () {
          $modalLoader.removeClass('hidden')
          $modalBodyContent.addClass('modal-body-content--loading')

          $(this).prop('disabled', true)
          $modal.find('.cancel-button').prop('disabled', true) // also disable the cancel button - the close button can still be pressed - but dont want them thinking they can quickly press the cancel button to revert the action during the ajax call if it takes a while
          // Ajax here
          const ajaxUrl = '/manage-my-booking/extras'
          $.ajax({
            type: 'POST',
            url: ajaxUrl,
            cache: false,
            contentType: 'application/json',
            data: JSON.stringify(updates),
            processData: false,
            dataType: 'json',
            success: function (response) {
              $modal.modal('hide')

              if (response.isAdding === true && response.depositAvailable === false) {
                // Show a modal to inform the customer they need to make payment
                createAlert('Make Payment', 'As you have added extras to your booking, you will need to pay for these now. Please click <strong><a href="/manage-my-booking/payment">here</a></strong> to make payment.', {
                  alertType: 'info',
                  onHide: function () {
                    window.location = '/manage-my-booking/summary'
                  }
                })
              } else {
                createAlert('Extras Updated', `
                    Your extras have been updated.
                `, {
                  alertType: 'success',
                  onHide: function () {
                    window.location = '/manage-my-booking/summary'
                  }
                })
              }
            },
            error: function (response) {
              const title = 'Update Error'
              let errorMessageHtml = 'Sorry there seems to have been an error updating these extras - please try again or contact us if the issue persists'
              switch (response.status) {
                case 401:
                  errorMessageHtml = 'Sorry you seem to have been logged out - please log back in <strong><a href="/manage-my-booking/login">here</a></strong>'
                  break
              }

              createAlert(title, errorMessageHtml, {
                alertType: 'danger'
              })

              $modal.modal('hide')
            },
            complete: function () {
              $modalLoader.addClass('hidden')
              $modalBodyContent.removeClass('modal-body-content--loading')
            }
          })
        })

        /**
         * resets the modal buttons and loaders as not being disabled or visible
         */
        const resetModalState = function () {
          $updateButton.prop('disabled', false)
          $cancelButton.prop('disabled', false)
          $modal.find('.modal-body__loader').addClass('hidden')
          $modal.find('.modal-body-content').removeClass('modal-body-content--loading')
        }

        /**
         * re-draws all the content on the modal for editing extras quantities and handles the select values being changed, updating the totals and populating the updates object to submit to the api when the update button is pressed
         */
        $modal.on('show.bs.modal', function (e) {
          resetModalState()
          const $button = $(e.relatedTarget)

          // Edit Title
          $modal.find('.modal-title').text($button.data('title'))

          // Extract data attributes from the button
          const price = $button.data('price')
          const name = $button.data('name')
          const extraId = $button.data('extra-id')
          const purchasedInfo = $button.data('purchased-info')
          const options = $button.data('options')
          const optionYesOrNo = isNaN(options[0])// this will be "No" or 0
          const paused = $button.data('paused')
          // Disable the update button
          $updateButton.prop('disabled', true)

          // Local variables
          let totalPrice = 0
          const priceDifference = 0

          // create an object to store arrays of purchased extras with unique prices and durations
          const purchasedExtrasForDifferentAmountsAndDurations = {}

          let purchased; let uniqueString; let itemised
          for (const i in purchasedInfo) {
            purchased = purchasedInfo[i]
            totalPrice += purchased.amount // keep a tally of the amount for all extras
            for (const j in purchased.itemised) {
              itemised = purchased.itemised[j]
              uniqueString = []
              uniqueString.push(itemised.bookChargeAmount.numberFormat(2))
              if (purchased.hasOwnProperty('duration')) {
                uniqueString.push(purchased.duration.from)
                uniqueString.push(purchased.duration.nights)
              }
              uniqueString = uniqueString.join('_')
              if (!purchasedExtrasForDifferentAmountsAndDurations.hasOwnProperty(uniqueString)) {
                purchasedExtrasForDifferentAmountsAndDurations[uniqueString] = {
                  qty: 0,
                  priceEach: itemised.bookChargeAmount, // this will be the same for all of them as we're uniqueing it on the price as being part of it
                  villaBookExtraIds: []
                }
              }
              purchasedExtrasForDifferentAmountsAndDurations[uniqueString].qty++
              purchasedExtrasForDifferentAmountsAndDurations[uniqueString].villaBookExtraIds.push(itemised.villaBookExtraId)
              if (purchased.hasOwnProperty('durationFormatted')) {
                purchasedExtrasForDifferentAmountsAndDurations[uniqueString].durationFormatted = purchased.durationFormatted
              }
            }
            // console.log(purchasedExtrasForDifferentAmountsAndDurations);
          }

          /*
            default row = current price + no duration string unless its an optionYesOrNo
            other rows = other prices with or without duration strings
          */

          // build out options rows for the extras - we need a defaultRow - which is the extra for the full duration
          const optionsRows = []
          const defaultRow = {
            priceEach: price,
            qty: 0
          }
          let extrasMatchingThisString; let newRow; let currentExtraPriceUniqueString
          // if its an extra that is optionYesOrNo - edit the default row if purchased for qty of 1, the price as per the purchased extra and add the duration if the purchased one has a different duration
          if (optionYesOrNo) {
            // we can only have 1 selected product
            if (purchasedInfo.length) {
              defaultRow.qty = purchasedInfo[0].qty // this should be a maximum of 1
              defaultRow.priceEach = purchasedInfo[0].amount
              if (purchasedInfo[0].hasOwnProperty('durationFormatted')) {
                defaultRow.durationFormatted = purchasedInfo[0].durationFormatted
              }
              defaultRow.villaBookExtraIds = [purchasedInfo[0].itemised[0].villaBookExtraId]
            }
            optionsRows.push(defaultRow)
          } else { // else we can have quantities of products - edit the default row qty and price if we have any for the full duration - and then add the non default priced ones and ones with durations
            // check if we have any items for the full duration and the current price
            // create a string to identify if the extra is at the current price without a duration
            currentExtraPriceUniqueString = price.numberFormat(2)
            if (purchasedExtrasForDifferentAmountsAndDurations.hasOwnProperty(currentExtraPriceUniqueString)) {
              extrasMatchingThisString = purchasedExtrasForDifferentAmountsAndDurations[currentExtraPriceUniqueString] // we have extras for the full duration - we can only have an item 0 in this array
              newRow = JSON.parse(JSON.stringify(defaultRow))// clone the default row to modify
              newRow.priceEach = extrasMatchingThisString.priceEach
              newRow.qty = extrasMatchingThisString.qty
              newRow.villaBookExtraIds = extrasMatchingThisString.villaBookExtraIds
              optionsRows.push(newRow)
            } else {
              // we always need the default row
              optionsRows.push(defaultRow)
            }
            const allUniquePurchasedExtraStrings = Object.keys(purchasedExtrasForDifferentAmountsAndDurations)
            // add addtional ones with different durations or prices to the default full duration one
            for (var i in allUniquePurchasedExtraStrings) {
              uniqueString = allUniquePurchasedExtraStrings[i]
              if (uniqueString === currentExtraPriceUniqueString) {
                // default row - already added above
                continue
              }
              extrasMatchingThisString = purchasedExtrasForDifferentAmountsAndDurations[uniqueString]
              newRow = JSON.parse(JSON.stringify(defaultRow))// clone the default row to modify
              newRow.priceEach = extrasMatchingThisString.priceEach
              newRow.qty = extrasMatchingThisString.qty
              if (extrasMatchingThisString.hasOwnProperty('durationFormatted')) {
                newRow.durationFormatted = extrasMatchingThisString.durationFormatted
              }
              newRow.nonDefault = true
              newRow.villaBookExtraIds = extrasMatchingThisString.villaBookExtraIds
              optionsRows.push(newRow)
            }
          }

          /**
           * Function that builds out the html for the select form for selecting the quantity for each extra
           * @param array options
           * @param integer quantitySelected
           * @param capAtQuantity boolean this will have the maximum select amount limited to the qty selected
           * @return string html select form
           */
          const buildOptionsHTML = function (options, quantitySelected, capAtQuantity) {
            // Build <select> options HTML
            const optionsHTML = []
            const selectOptions = JSON.parse(JSON.stringify(options)) // copy the options array to a local version
            optionsHTML.push('<div class="form-group">')
            optionsHTML.push('<select class="form-control">')
            // increase values in the options if quantity selected is not within the options - this could mean we have 6 of something but only upto 4 in the options
            let maxOption = selectOptions.length - 1
            while (quantitySelected > maxOption) {
              selectOptions.push(++maxOption)
            }
            for (const value in selectOptions) {
              if (capAtQuantity && value > quantitySelected) {
                continue
              }
              optionsHTML.push('<option value="' + value + '"' + (value == quantitySelected ? 'selected' : '') + '>' + selectOptions[value] + '</option>')
            }
            optionsHTML.push('</select>')
            optionsHTML.push('</div>')
            return optionsHTML.join('')
          }
          const extraRows = []
          let extraRowHTML; let rowInfo; let capAtQuantity
          for (var i in optionsRows) {
            rowInfo = optionsRows[i]
            extraRowHTML = []
            extraRowHTML.push('<tr>')
            extraRowHTML.push('<td>' + name + (rowInfo.hasOwnProperty('durationFormatted') ? '<br /><span style="font-size:12px;">(' + rowInfo.durationFormatted + ')</span>' : '') + '</td>')
            extraRowHTML.push('<td>£' + rowInfo.priceEach.numberFormat(2) + '</td>')
            capAtQuantity = !!rowInfo.hasOwnProperty('nonDefault') // this stops them being able to add additional ones that are not the full duration
            extraRowHTML.push('<td>' + buildOptionsHTML(options, rowInfo.qty, paused ? rowInfo.qty : capAtQuantity) + '</td>')
            extraRowHTML.push('</tr>')
            extraRows.push(extraRowHTML.join(''))
          }

          // Append table to modal
          $modal.find('.modal-body-content').html(
            '<table class="table">' +
            '<colgroup>' +
            '<col style="width:30%">' +
            '<col style="width:30%">' +
            '<col style="width:40%">' +
            '</colgroup>' +
            '<thead>' +
            '<tr>' +
            '<th>Extra</th>' +
            '<th>Price</th>' +
            '<th>' + (optionYesOrNo ? 'Required' : 'Quantity') + '</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            extraRows.join('') +
            '<tr>' +
            '<td></td>' +
            '<td><b>Total</b></td>' +
            '<td class="total-price">' +
            '£<span>' + totalPrice.numberFormat(2) + '</span>' +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td class="warning"></td>' +
            '<td class="warning"><b>Price Difference</b></td>' +
            '<td class="price-difference warning">' +
            '£<span>' + priceDifference.numberFormat(2) + '</span>' +
            '</td>' +
            '</tr>' +
            '<tr class="refund" style="display:none;">' +
            '<td></td>' +
            '<td></td>' +
            '<td class="danger">' +
            '<i>* Your balance will be reduced to this amount</i>' +
            (paused ? '<br/><br/><b>We no longer offer this extra, if you remove this, you will not be able to add it at a later date.' : '') +
            '</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>'
          )

          // Listen for when select input changes
          $modal.find('select').on('change', function () {
            // reset the updates object - defined in outer scope where it needs to be accessed
            updates.add = 0// new ones will be added at the full duration for the current cost - existing ones qty cannot be increased
            updates.removeVillaBookExtraIds = []// this will be an array of villaBookExtraIds that need to be removed
            updates.extraId = extraId // the extra id we are modifying

            // console.dir('changed')
            const $changedOption = $(this)
            const $selectForms = $changedOption.closest('table').find('select')
            let priceOriginal = 0
            let priceNow = 0
            const selectedOriginal = []
            const selectedNow = []
            let $selectForm
            $selectForms.each(function () {
              $selectForm = $(this)
              selectedNow.push(parseInt($selectForm.val()))
            })
            // update all the totals and prices
            let qtyDifference; let villaBookExtraIdsToRemove
            for (const i in optionsRows) {
              priceOriginal += optionsRows[i].qty * optionsRows[i].priceEach
              priceNow += selectedNow[i] * optionsRows[i].priceEach
              selectedOriginal.push(optionsRows[i].qty) // store the qty of what they were originally so we can see if there are updates
              if (selectedNow[i] !== selectedOriginal[i]) { // its been changed
                // its being modified
                qtyDifference = selectedNow[i] - selectedOriginal[i]
                if (qtyDifference > 0) {
                  // we can only add on the default row
                  updates.add = qtyDifference
                } else {
                  // we're removing extras - we will have villaBookExtraIds
                  villaBookExtraIdsToRemove = optionsRows[i].villaBookExtraIds.slice(qtyDifference)
                  // add these villaBookExtraIds to the ones to remove
                  for (const j in villaBookExtraIdsToRemove) {
                    updates.removeVillaBookExtraIds.push(Number(villaBookExtraIdsToRemove[j]))
                  }
                }
              }
            }
            const isUpdated = JSON.stringify(selectedOriginal) !== JSON.stringify(selectedNow)
            let priceDifference = priceNow - priceOriginal

            const $refundWarning = $modal.find('.refund')
            const refundLineDisplay = priceDifference < 0 ? '' : 'none'
            $refundWarning.css('display', refundLineDisplay)

            $updateButton.prop('disabled', !isUpdated)

            priceDifference = Number(priceDifference).numberFormat(2)
            totalPrice = Number(priceNow).numberFormat(2)

            $modal.find('.total-price span').html(totalPrice)
            $modal.find('.price-difference span').html(priceDifference)
          })
        })
      }
    },
    manage_my_booking_passengers: {
      init: function () {
        alert('WIP - needs implementing')
        const $modal = $('#manage-my-booking-passenger-model')

        $modal.on('show.bs.modal', function (e) {
          const $parent = $(e.relatedTarget)
          const $updateButton = $modal.find('.btn-primary')

          const title = $parent.find('.title').text()
          const forename = $parent.find('.forename').text()
          const surname = $parent.find('.surname').text()
          const dob = $parent.find('.dob').text()

          $modal.find('.modal-title').text('Edit ' + forename + ' ' + surname)

          $modal.find('.modal-body-content').html(
            '<div class="form-group">' +
            '<label for="title">*Title</label>' +
            '<select class="form-control" id="title">' +
            '<option value="Mr" ' + (title == 'Mr' ? 'selected' : '') + '>Mr</option>' +
            '<option value="Mrs" ' + (title == 'Mrs' ? 'selected' : '') + '>Mrs</option>' +
            '<option value="Miss" ' + (title == 'Miss' ? 'selected' : '') + '>Miss</option>' +
            '<option value="Ms" ' + (title == 'Ms' ? 'selected' : '') + '>Ms</option>' +
            '<option value="Dr" ' + (title == 'Dr' ? 'selected' : '') + '>Dr</option>' +
            '<option value="Prof" ' + (title == 'Prof' ? 'selected' : '') + '>Prof</option>' +
            '<option value="Rev" ' + (title == 'Rev' ? 'selected' : '') + '>Rev</option>' +
            '<option value="Sir" ' + (title == 'Sir' ? 'selected' : '') + '>Sir</option>' +
            '<option value="Lady" ' + (title == 'Lady' ? 'selected' : '') + '>Lady</option>' +
            '</select>' +
            '</div>' +
            '<div class="form-group">' +
            '<label for="forename">*Forename</label>' +
            '<input type="text" class="form-control" id="forename" value="' + forename + '">' +
            '</div>' +
            '<div class="form-group">' +
            '<label for="surname">*Surname</label>' +
            '<input type="text" class="form-control" id="surname" value ="' + surname + '">' +
            '</div>' +
            '<div class="form-group">' +
            '<label for="dob">*Date of Birth</label>' +
            '<input type="date" class="form-control" id="dob" value="' + dob + '">' +
            '</div>'
          )

          $updateButton.on('click', function () {
            // Ajax here

            // Update Row
            $parent.find('.title').html($modal.find('#title').val())
            $parent.find('.forename').html($modal.find('#forename').val())
            $parent.find('.surname').html($modal.find('#surname').val())
            $parent.find('.dob').html($modal.find('#dob').val())
          })
        })
      }
    },
    manage_my_booking_upsert_password: {
      init: function () {
        return import('./classes/manage-my-booking/upsertPassword.js')
      }
    },
    direct_debit: {
      init: function () {
        return import('./classes/manage-my-booking/directDebit.js')
      }
    },
    manage_my_booking_checklists_villa_details: {
      init: function () {
        return import('./classes/manage-my-booking/checklists/villaGuests.js')
      }
    },
    manage_my_booking_checklists_flight_number: {
      init: function () {
        return import('./classes/manage-my-booking/checklists/flightNumber.js')
      }
    },
    checkout_flights_flight_chosen: {
      init: function () {
        analyticsEvent('update_checkout')
      }
    }
  }

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing
  const UTIL = {
    fire: function (func, funcname, args) {
      let fire
      const namespace = Debbies
      funcname = (funcname === undefined) ? 'init' : funcname
      fire = func !== ''
      fire = fire && namespace[func]
      fire = fire && typeof namespace[func][funcname] === 'function'

      if (fire) {
        namespace[func][funcname](args)
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common')

      // Fire page-specific init JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm)
      })
    },
    getUrlParameter: function (parameter) {
      // Get url parameter
      const url = window.location.href
      let urlParams = url.split('?')
      let parameterValue = null

      if (urlParams.length > 1) {
        urlParams = url.split('?')[1].split('&')
        for (let i = 0; i < urlParams.length; i++) {
          const singleParam = urlParams[i].split('=')
          if (singleParam[0] == parameter) {
            parameterValue = singleParam[1]
            break
          }
        }
      }

      return parameterValue
    }
  }

  // Load Events
  $(document).ready(UTIL.loadEvents)
})(jQuery) // Fully reference jQuery after this point.

// send-to-friend submit button enable or disable function used in the recaptcha script

var disableSendTofriendButton = function () {
  $('#send-pdf-button').attr('disabled', 'disabled')
}

const enableSendToFriendButton = function () {
  $('#send-pdf-button').removeAttr('disabled')
}

// Mailing list submit button enable or disable function used in the repatcha script
const enableMailingListButton = function () {
  $('#send-mail-list-button').prop('disabled', false)
}

var disableMailingListButton = function () {
  $('#send-mail-list-button').prop('disabled', true)
}

// Expose the functions to global scope, for google recaptcha to see
// Webpack localizes the functions to the local scope, therefore any third-party library cannot access them unless they are global
window.enableSendToFriendButton = enableSendToFriendButton
window.disableSendTofriendButton = disableSendTofriendButton
window.enableMailingListButton = enableMailingListButton
window.disableMailingListButton = disableMailingListButton

function initMap() {
  const mapStyles = [
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'administrative.neighborhood',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#fafafb'
        }
      ]
    },
    {
      featureType: 'landscape.natural',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#fafafb'
        }
      ]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.attraction',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.business',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.government',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.medical',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.park',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.place_of_worship',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.school',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'poi.sports_complex',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#b8d432'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#b8d432'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#8dd8f8'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#8dd8f8'
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'road.highway.controlled_access',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#00baf2'
        }
      ]
    },
    {
      featureType: 'road.highway.controlled_access',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#00baf2'
        }
      ]
    },
    {
      featureType: 'road.highway.controlled_access',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'on'
        }
      ]
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#fdfefe'
        }
      ]
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#18b288'
        },
        {
          lightness: 55
        }
      ]
    },
    {
      featureType: 'road.local',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'transit',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#c7eafc'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#c7eafc'
        }
      ]
    }
  ]

  const florida = { lat: 28.301885, lng: -81.564533 }

  // The map, centered at Florida
  const map = new google.maps.Map(
    document.getElementById('map'),
    {
      zoom: 12,
      center: florida,
      styles: mapStyles,
      mapTypeControl: false,
      scaleControl: true,
      rotateControl: false,
      streetViewControl: false
    }
  )

  const infowindow = new google.maps.InfoWindow({
    content: '',
    maxWidth: 500,
    disableAutoPan: true
    // pixelOffset: new google.maps.Size(-10, -10)
  })

  const markers = {}
  const locationInfo = {}
  const closeInfoWindow = function () {
    infowindow.setContent('')
    infowindow.close()
  }
  const openInfoWindow = function (markerType, markerIndex) {
    closeInfoWindow()
    if (locationInfo.hasOwnProperty(markerType) && markers.hasOwnProperty(markerType)) {
      if (locationInfo[markerType].hasOwnProperty(markerIndex) && markers[markerType].hasOwnProperty(markerIndex)) {
        infowindow.setContent(locationInfo[markerType][markerIndex])
        infowindow.open(map, markers[markerType][markerIndex])
        // checkAndRepositionInfoWindow(); // work in
      }
    }
  }
  /*
  var pixelsFromLatLng = function(latLng, map) {
  //http://krasimirtsonev.com/blog/article/google-maps-api-v3-convert-latlng-object-to-actual-pixels-point-object
  var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
  var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
  var scale = Math.pow(2, map.getZoom());
  var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
  return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}
 
var checkAndRepositionInfoWindow = function(){
setTimeout(function(){ // have to wrap this in a next tick function as the first item doesn't exist when first called
var infoWindowMarkerPixelsLocation = pixelsFromLatLng(infowindow.getPosition(),map)
var $infoWindow = $('.gm-style-iw').parent();
var infoWindowWidth = $infoWindow.width();
var infoWindowHeight = $infoWindow.height();
var $keySlider = $(".key-slider");
var keySliderLeft = $keySlider.position().left
var keySliderWidth = $keySlider.width();
var minX = keySliderLeft + keySliderWidth;
var actualLeft = infoWindowMarkerPixelsLocation.x - infoWindowWidth/2;
var xOffset = 0;
if(actualLeft < minX){
xOffset = minX- actualLeft;
}
infowindow.setOptions({
pixelOffset:new google.maps.Size(xOffset,0)
})
 
},0)
}
*/
  map.addListener('click', function () {
    closeInfoWindow()
  })

  Object.keys(mapMarkers).forEach(function (key, index) {
    locationInfo[key] = []

    // Note: The code uses the JavaScript Array.prototype.map() method to
    // create an array of markers based on a given "locations" array.
    // The map() method here has nothing to do with the Google Maps API.
    markers[key] = mapMarkers[key].map(function (location, i) {
      locationInfo[key][i] = ''

      let titleOnly = true
      if (location.hasOwnProperty('image') && location.hasOwnProperty('url')) {
        titleOnly = false
      }

      if (titleOnly) {
        locationInfo[key][i] += '<strong>' + location.name + '</strong>'
      } else {
        const columnWidths = {
          img: 'col-sm-5',
          text: 'col-sm-12'
        }

        locationInfo[key][i] += '<div class="info-window-inner">'
        locationInfo[key][i] += '<div class="row">'

        if (location.hasOwnProperty('image')) {
          if (location.image) {
            columnWidths.text = 'col-sm-7'

            locationInfo[key][i] += '<div class="' + columnWidths.img + '">'
            locationInfo[key][i] += '<div class="map-thumb-image ' + key + '" style="background-image: url(' + location.image.imgUrl + ');"></div>'
            locationInfo[key][i] += '</div>'
          }
        }

        let locationUrl = ''
        let searchUrl = ''

        if (location.hasOwnProperty('url')) {
          locationUrl = location.url
        }

        if (location.hasOwnProperty('communityId') && location.hasOwnProperty('searchUrl')) {
          searchUrl = location.searchUrl
        }

        locationInfo[key][i] += '<div class="' + columnWidths.text + '">'

        locationInfo[key][i] += '<strong style="display: block; margin-bottom: 5px;">' + location.name + '</strong>'

        if (location.hasOwnProperty('attractionDesc')) {
          locationInfo[key][i] += '<p style="font-size: 1.2em; margin-bottom: 5px;">' + location.attractionDesc + '</p>'
        }

        if (locationUrl !== '') {
          locationInfo[key][i] += '<p style="font-size: 1.2em; margin-bottom: 5px;"><a href="' + locationUrl + '">Read more about ' + location.name + '</a></p>'
        }

        if (searchUrl !== '') {
          locationInfo[key][i] += '<p style="font-size: 1.2em; margin-bottom: 5px;"><a href="' + searchUrl + '">View Properties on ' + location.name + '</a></p>'
        }

        if (location.hasOwnProperty('facilities')) {
          locationInfo[key][i] += '<ul class="feature-icons" style="margin: 0; padding: 0; list-style: none;">'
          for (let a = 0; a < location.facilities.length; a++) {
            const desc = location.facilities[a].title
            const icon = location.facilities[a].iconUrl

            locationInfo[key][i] += '<li style="float: left; width: 30px; padding: 2px;">'
            locationInfo[key][i] += '<img data-toggle="popover" data-trigger="hover" data-content="' + location.facilities[a].title + '" src="' + icon + '" title="' + desc + '" alt="' + desc + '" style="max-width: 100%" class="img-responsive"/>'
            locationInfo[key][i] += '</li>'
          }
          locationInfo[key][i] += '</ul>'
        }

        locationInfo[key][i] += '</div>'

        locationInfo[key][i] += '</div>'
        locationInfo[key][i] += '</div>'
      }

      const marker = new google.maps.Marker({
        position: {
          lat: parseFloat(location.lat),
          lng: parseFloat(location.lon)
        },
        map,
        icon: '/dist/images/map-markers/' + key + '.png',
        title: location.name
      })

      marker.addListener('mouseover', function () {
        openInfoWindow(key, i)
      })

      marker.addListener('click', function () {
        map.panTo({
          lat: marker.position.lat(),
          lng: marker.position.lng()
        })
        openInfoWindow(key, i)
      })

      return marker
    })
  })

  /**
* Map controls below this line
*/

  // Initialise map controls
  map.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById('key'))

  // Toggle map keys
  $('.key-group h3').each(function () {
    const group = $(this).attr('data-group')

    $(this).on('click', function () {
      $('.key-group h3').toggleClass('closed').toggleClass('open')

      $('[data-accordion]').each(function () {
        if ($(this).attr('data-accordion') === group) {
          $(this).slideToggle()
        } else {
          $(this).slideUp()
        }
      })
    })
  })

  // Navigate around the map, using the map key
  $('[data-marker]').each(function () {
    const checkBoxMarker = $(this).attr('data-marker')
    const dataMarker = checkBoxMarker.split('-')
    const markerType = dataMarker[0]
    const markerIndex = dataMarker[1]

    $(this).mouseenter(function () {
      // console.log(dataMarker);
      markers[markerType][markerIndex].setAnimation(google.maps.Animation.BOUNCE)
      // console.log('mouse enter');
    }).mouseleave(function () {
      markers[markerType][markerIndex].setAnimation(-1)
      // console.log('mouse leave');
    })

    $(this).on('click', function () {
      closeInfoWindow()

      // If checkbox for marker is unchecked, re-check it
      if (!$('#' + checkBoxMarker).is(':checked')) {
        $('#' + checkBoxMarker).click()
      }

      // Close menu, if window width is small
      if ($(window).width() < 500) {
        $('#key_toggle').click()
      }

      map.panTo({
        lat: markers[markerType][markerIndex].position.lat(),
        lng: markers[markerType][markerIndex].position.lng()
      })

      let time = 500

      setTimeout(function () {
        map.setZoom(15)
      }, time)

      time += 250

      setTimeout(function () {
        openInfoWindow(markerType, markerIndex)
      }, time)
    })
  })

  // Show / hide markers with checkboxes
  $('.marker-group input[type="checkbox"]').each(function () {
    $(this).on('change', function () {
      const dataMarker = $(this).attr('id').split('-')
      const markerType = dataMarker[0]
      const markerIndex = dataMarker[1]

      const markerCount = $('.marker-group input[type="checkbox"][data-markerprefix="' + markerType + '"]').length
      const visibleMarkers = $('.marker-group input[type="checkbox"][data-markerprefix="' + markerType + '"]:checked').length

      if (visibleMarkers > 0) {
        if (visibleMarkers === markerCount) {
          $('.showhide-' + markerType + '-prefix').text('Hide all')
          $('.showhide-' + markerType + '-suffix').text('')
        }

        if (visibleMarkers < markerCount) {
          $('.showhide-' + markerType + '-prefix').text('Showing ' + visibleMarkers + ' of ' + markerCount)
          $('.showhide-' + markerType + '-suffix').text('')
        }
      }

      if (visibleMarkers <= 0) {
        $('.showhide-' + markerType + '-prefix').text('Show all')
        $('.showhide-' + markerType + '-suffix').text('')
      }

      if ($(this).is(':checked')) {
        markers[markerType][markerIndex].setMap(map)
      } else {
        markers[markerType][markerIndex].setMap(null)
      }
    })
  })

  // Show / hide all markers in each section
  $('.checkbox.toggle-all input[type="checkbox"]').each(function () {
    const keySection = $(this).attr('id').split('-')[1]

    $(this).on('change', function () {
      let checked = false

      if ($(this).is(':checked')) {
        checked = true
      }

      $('[data-prefix="' + keySection + '"] input[type="checkbox"]').each(function () {
        if ($(this).is(':checked') !== checked) {
          $(this).click() // simulates a click on each applicable checkbox -> causes method above to handle show/hide
        }
      })
    })
  })

  // Show / hide map key
  $('#key_toggle').on('click', function (e) {
    e.preventDefault()
    if ($('.key-slider').hasClass('left')) {
      $('.key-slider').removeClass('left')
      $(this).removeClass('left')
      $(this).children($('.fa')).addClass('fa-angle-left')
      $(this).children($('.fa')).removeClass('fa-angle-right')
    } else {
      $('.key-slider').addClass('left')
      $(this).addClass('left')
      $(this).children($('.fa')).removeClass('fa-angle-left')
      $(this).children($('.fa')).addClass('fa-angle-right')
    }
  })

  // Hide map key if map is initialised with a window with smaller than 500px
  if ($(window).width() < 500) {
    $('#key_toggle').click()
  }
}

// Expose the functions to global scope, for google map to see
// Webpack localizes the functions to the local scope, therefore any third-party library cannot access them unless they are global
window.initMap = initMap
